<template >
  <div class="whole-page">

    <div class="header">
      <div class="header-icon" @click="user_type!=='普通用户'&&(platform==='online'?$router.push('/onlineApp_desktop'):user_type==='老师'?$router.push('/teacherExam_desktop'):$router.push('/studentExam_desktop'))" ></div>
      <div class="header-title">{{ platform==='online'?'虚拟仿真教学系统':'虚拟仿真模考系统' }}</div>
      <div class="message-ding"
           @click="$router.push('/userMessage_desktop')">
        <i class="el-icon-message-solid"
           style="font-size: 0.7vw"></i>
        <div class="red-point"
             v-if="messageCount>0"><span style="color: white;">{{messageCount>9?'9+':messageCount}}</span></div>
      </div>
      <div class="header-pic"
           @click="showCard=!showCard">

        <div class="user-card"
             ref="user-card-list"
             v-if="showCard">
          <div class="user-card-pic"></div>
          
            <div style='position: absolute;z-index:999'>
              <div class="user-msg">
                <span style="display: inline-block">{{loginUid=='250'?'249':loginUid}}</span>
                <span style="display: inline-block">{{'ID：'+(loginAccount.length>7?loginAccount.slice(0,7)+'...':loginAccount)}}</span>
              </div>
            </div>
          


          <div class="user-btn-list">
            <div class="user-card-btn">
              <img class="user-btn-pic"
                   src="http://data.xiyilab.com/web/main/static/home/p__基本资料大icon-拷贝.png">
              <div class="user-btn-text">个人中心</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="main">

      <crumb-bread v-if="0" :router="router">
      </crumb-bread>

      <div class="background-card">
        <div class="card-left">
          <div class="go-back" @click="platform==='online'?$router.push('/onlineApp_desktop'):user_type==='老师'?$router.push('/teacherExam_desktop'):$router.push('/studentExam_desktop')" v-if="user_type!=='普通用户'">
            <i class="el-icon-arrow-left"></i>回到{{platform==='online'?'同步实验':'模拟考试'}}
          </div>
          <div class="card-pic">
            <div class="pic">
              <div class="pic-shadows">编辑</div>
            </div>
            <!--              <div class="username">{{person_msg.username}}</div>-->
            <div class="account">{{(loginAccount&&loginAccount.length>12?loginAccount.slice(0,12)+'...':loginAccount)}}
              <div class="user-id">{{user_type}}</div>
            </div>

          </div>
          <routerList_desktop :activeBtn="activeRouterBtn" @switchRight="changeRight"></routerList_desktop>
        </div>

        <div v-show="accountActive"
             class="card-right">
          <div class="account-line">
            <div class="line-font">
              <div class="line-font-left"></div>
              <div class="line-font-right" style="background-image: linear-gradient(90deg, rgb(58, 192, 141) 0%, transparent 100%);">
                <div style="position: absolute;color: white;font-size: 1vw;line-height: 1.5vw;font-family: test;letter-spacing: 1px;left: 0.5vw">账号信息</div>
              </div>
            </div>
            <div class="under-line"></div>
          </div>
          <div style="width: 80%;background-color: white;margin: 1vw auto;height: 4vw">
            <div class="account-msg">
              <div class="msg-box">
                账号ID：{{loginUid=='250'?'249':loginUid}}
              </div>
              <div class="msg-box">
                账号类型：{{user_type}}
              </div>
            </div>
          </div>
          <div class="account-line" style="margin-top: 2vw">
            <div class="line-font">
              <div class="line-font-left" style="background-color: rgb(58, 112, 192)"></div>
              <div class="line-font-right" style="background-image: linear-gradient(90deg, rgb(58, 112, 192) 0%, transparent 100%);">
                <div style="position: absolute;color: white;font-size: 1vw;line-height: 1.5vw;font-family: test;letter-spacing: 1px;left: 0.5vw">个人信息</div>
              </div>
            </div>
            <div class="under-line"></div>
          </div>
          <div class="person-msg-shell">
            <div class="personal-msg">
              <div style="margin-top: 1vw">
                昵称：<el-input style="width: 10vw;"
                             :placeholder="person_msg.username||'wkq'"
                             v-model="formData.username"></el-input>
              </div>
              <div style="margin-top: 1.5vw">
                性别：
                <label><input name="sex"
                              type="radio"
                              class="radio"
                              @click="formData.sex='male'"
                              :checked="person_msg.sex==='male'?true:false" />男 </label>
                <label><input name="sex"
                              type="radio"
                              class="radio"
                              @click="formData.sex='female'"
                              :checked="person_msg.sex==='female'?true:false" />女 </label>
              </div>
              <div style="width: 100%;margin-top: 2vw;margin-bottom: 2vw">
                所在城市：
                <el-select placeholder="省"
                           style="width: 8vw"
                           v-model="applyForm.province"
                           @change="provinceInput">
                  <el-option v-for="item in province"
                             :key="item.province_code"
                             :label="item.province_name"
                             :value="JSON.stringify({name:item.province_name,code:item.province_code})">
                  </el-option>
                </el-select>
                <el-select placeholder="市"
                           style="width: 10vw"
                           v-model="applyForm.city"
                           @change="cityChange"
                >
                  <el-option v-for="item in city"
                             :key="item.city_code"
                             :label="item.city_name"
                             :value="JSON.stringify({name:item.city_name,code:item.city_code})">
                  </el-option>
                </el-select>
                <el-select placeholder="区"
                           style="width: 8vw"
                           @change="getSchoolList"
                           v-model="applyForm.area">
                  <el-option v-for="item in area"
                             :key="item.county_code"
                             :label="item.county_name"
                             :value="JSON.stringify({name:item.county_name,code:item.county_code})">
                  </el-option>
                </el-select>

              </div>
              <div style="width: 100%;display: flex;flex-wrap: nowrap;justify-content: flex-start">
                所在学校或企业：
                <el-select v-model="applyForm.school"
                           placeholder="学校">
                  <el-option v-for="item in schoolList"
                             :key="item.school_code"
                             :label="item.school_name"
                             :value="JSON.stringify({name:item.school_name,code:item.school_code})">
                  </el-option>
                </el-select>
                <div style="margin-left: 2vw">
                  班级：
                </div>
                <el-input placeholder="班级" style="width: 20%;" v-model="formData.classroom"></el-input>
              </div>
              <el-button style="margin: 2vw auto"
                         @click="submitFormData">保存</el-button>
            </div>
          </div>

        </div>

        <div v-show="safeActive"
             class="card-right">
          <div class="account-line">
            <div class="line-font">
              <div class="line-font-left" style="background-color: rgb(255, 212, 80)"></div>
              <div class="line-font-right" style="background-image: linear-gradient(90deg, rgb(255, 212, 80) 0%, transparent 100%);">
                <div style="position: absolute;color: white;font-size: 1vw;line-height: 1.5vw;font-family: test;letter-spacing: 1px;left: 0.5vw">账号安全</div>
              </div>
            </div>
            <div class="under-line"></div>
          </div>

          <div class="safe-list">
            <div style="height: 3vw;position: relative;margin-top:1vw"
                 v-for="(item,index) in user_privacy"
                 :key="index">
              <div class="list-title"
                   v-if="item.label!=='密码'">绑定{{ item.label }}:</div>
              <div class="list-title"
                   v-if="item.label==='密码'&&item.value===''">设置{{ item.label }}:</div>
              <div class="list-title"
                   v-if="item.label==='密码'&&item.value!==''">修改{{ item.label }}:</div>
              <el-button class="list-btn"
                         type="primary"
                         size="mini"
                         @click="showDialog(index)"
                         v-if="item.label!=='密码'">{{item.value?'更换'+item.label:'绑定'}}</el-button>
              <el-button class="list-btn"
                         type="primary"
                         size="mini"
                         @click="showDialog(index)"
                         v-if="item.label==='密码'">{{item.value?'修改'+item.label:'设置'}}</el-button>

              <div class="list-label"
                   v-if="item.label!=='密码'">{{item.value?'已绑定:'+item.value:'未绑定，绑定后可以快捷登录、找回密码'}}</div>
              <div class="list-label"
                   v-if="item.label==='密码'">{{item.value?'已设置':'未设置，绑定后可以使用密码快捷登录'}}</div>
            </div>
          </div>
        </div>

        <div v-show="appActive"
             class="card-right">
          <div class="account-line" style="margin-bottom: 0.5vw">
            <div style="display: flex;flex-direction: row;flex-wrap: nowrap">
              <div class="line-font" @click="switchPage('历史实验')">
                <div class="line-font-left" :style="{backgroundColor: activePage==='history'?'rgb(239, 101, 65)':'transparent'}"></div>
                <div class="line-font-right" :style="{backgroundImage:activePage==='history'?'linear-gradient(90deg, rgb(239, 101, 65) 0%, transparent 100%)':''}">
                  <div style="position: absolute;color: white;font-size: 1vw;line-height: 1.5vw;font-family: test;letter-spacing: 1px;left: 0.5vw" :style="{color: activePage==='history'?'white':'black'}">历史记录</div>
                </div>
              </div>
              <div class="line-font" @click="switchPage('我的收藏')">
                <div class="line-font-left" :style="{backgroundColor: activePage==='collection'?'rgb(239, 101, 65)':'transparent'}"></div>
                <div class="line-font-right" :style="{backgroundImage:activePage==='collection'?'linear-gradient(90deg, rgb(239, 101, 65) 0%, transparent 100%)':''}">
                  <div style="position: absolute;color: white;font-size: 1vw;line-height: 1.5vw;font-family: test;letter-spacing: 1px;left: 0.5vw" :style="{color: activePage==='collection'?'white':'black'}">我的收藏</div>
                </div>
              </div>
            </div>

            <div class="under-line"></div>
          </div>
          <div v-if="activePage==='history'" style="display: flex;flex-direction: column;justify-content: flex-end;height: 80%">
            <div class="select-date">
              <el-button type="text"
                         class="select-text"
                         :class="{'active-select-text':activeselDate===item.date}"
                         @click="selectDate(item.date)"
                         v-for="item in dateList"
                         :key="item.date">{{item.label}}</el-button>
            </div>
            <div class="card-list"
                 v-if='historyCardList.length>0'>
              <div v-for="(item,index) in historyCardList"
                   class="card"
                   @click="openApp(item)"
                   :key="item.id">
                <div class="time-tag">
                  <div style="width: 100%;height: 0.8vw;text-align: center">
                    {{utc2beijing(item['created_at']).getFullYear()+
                  '-'+(parseInt(utc2beijing(item['created_at']).getMonth()+1)>=10?parseInt(utc2beijing(item['created_at']).getMonth()+1):('0'+parseInt(utc2beijing(item['created_at']).getMonth()+1).toString()))+
                  '-'+(utc2beijing(item['created_at']).getDate()>=10?utc2beijing(item['created_at']).getDate():('0'+utc2beijing(item['created_at']).getDate()))+' '
                  + (utc2beijing(item['created_at']).getHours()>=10?utc2beijing(item['created_at']).getHours():('0'+utc2beijing(item['created_at']).getHours()))+
                  ':'+(utc2beijing(item['created_at']).getMinutes()>10?utc2beijing(item['created_at']).getMinutes():('0'+utc2beijing(item['created_at']).getMinutes()))+
                  ':'+(utc2beijing(item['created_at']).getSeconds()>10?utc2beijing(item['created_at']).getSeconds():('0'+utc2beijing(item['created_at']).getSeconds()))}}
                  </div >
                </div>
                <div class="card-img" :class="{'phy-back':item['preview_img_uri']&&item['preview_img_uri'].indexOf('物理')!==-1,'chem-back':item['preview_img_uri'].indexOf('化学')!==-1,'bio-back':item['preview_img_uri'].indexOf('生物')!==-1}">
                  <img :src="item['preview_img_uri']||''"
                       :width="appWidth"
                       alt="">
                </div>
                <div class="card-title">
                  {{item.name.length>15?item.name.slice(0,15)+'...':item.name}}
                </div>
              </div>
            </div>
            <div v-else>
              <div style="width: 100%;height:60vh;display:flex;justify-content:center;align-items:center;margin-top:auto;margin-bottom: auto">暂无...</div>
            </div>
            <el-pagination class="pagination"
                           hide-on-single-page
                           background
                           :current-page="historypage.page"
                           @current-change="historyPaginationChange"
                           :page-size="historypage.limit"
                           layout="prev, pager, next"
                           :total="historypage.total">
            </el-pagination>
          </div>
          <div v-if="activePage==='collection'" style="display: flex;flex-direction: column;justify-content: flex-end;height: 80%">
            <div class="select-btn" v-if="0">
              <div class="select-chapter btn-list">
                <span class="label-list">学科：</span>
                <div class="btn-group">
                  <span style="display: inline-block"
                        class="version-btn"
                        v-for="item in subjectList"
                        @click="addTag(item.name)"
                        :class="{'active':item.active,'disable':!item.active}">{{item.name}}</span>
                </div>
              </div>
              <div class="select-version btn-list">
                <span class="label-list">教材：</span>
                <div class="btn-group">
                  <span style="display: inline-block"
                        class="version-btn"
                        v-for="item in versionList"
                        @click="addTag(item.name)"
                        :class="{'active':item.active,'disable':!item.active}">{{item.name}}</span>
                </div>
              </div>
              <div class="select-grade btn-list">
                <span class="label-list">年级：</span>
                <div class="btn-group">
                  <span style="display: inline-block"
                        class="version-btn"
                        v-for="item in gradeList"
                        @click="addTag(item.name)"
                        :class="{'active':item.active,'disable':!item.active}">{{item.name}}</span>
                </div>
              </div>
            </div>
            <div class="card-list"
                 v-if='collectCardList.length>0'>
              <div v-for="(item,index) in collectCardList"
                   class="card"
                   @click="openApp(item)"
                   :key="item.id">
                <div class="card-img" :class="{'phy-back':item.subject==='物理','chem-back':item.subject==='化学','bio-back':item.subject==='生物'}">
                  <img :src="item['app_platforms'][0]['preview_img_uri']||''"
                       :width="appWidth"
                       alt="图片丢失">
                </div>
                <div class="card-title">
                  {{item.name.length>15?item.name.slice(0,15)+'...':item.name}}
                </div>
              </div>
            </div>
            <div v-else>
              <div style="width: 100%;height:60vh;display:flex;justify-content:center;align-items:center;margin-top:auto;margin-bottom: auto">暂无...</div>
            </div>
            <el-pagination class="pagination"
                           hide-on-single-page
                           background
                           :current-page="collectionpage.page"
                           @current-change="collectPaginationChange"
                           :page-size="collectionpage.limit"
                           layout="prev, pager, next"
                           :total="collectionpage.total">
            </el-pagination>
          </div>
        </div>


        <div v-show="managerActive"
             class="card-right manage-table" style="overflow: auto;scrollbar-width: none;">

          <div class="account-line" style="margin-bottom: 0vw;margin-top: 0.5vw;width: 90%">
            <div style="display: flex;flex-direction: row;flex-wrap: nowrap">
              <div class="line-font" @click="managerShow='classroom'">
                <div class="line-font-left" :style="{backgroundColor: managerShow==='classroom'?'rgb(58, 112, 192)':'transparent'}"></div>
                <div class="line-font-right" :style="{backgroundImage:managerShow==='classroom'?'linear-gradient(90deg, rgb(58, 112, 192) 0%, transparent 100%)':''}">
                  <div style="position: absolute;color: white;font-size: 1vw;line-height: 1.5vw;font-family: test;letter-spacing: 1px;left: 0.5vw" :style="{color: managerShow==='classroom'?'white':'black'}">班级管理</div>
                </div>
              </div>
              <div class="line-font" v-if="managerShow!=='classroom'">
                <div class="line-font-left" :style="{backgroundColor: managerShow!=='classroom'?'rgb(58, 112, 192)':'transparent'}"></div>
                <div class="line-font-right" :style="{backgroundImage:managerShow!=='classroom'?'linear-gradient(90deg, rgb(58, 112, 192) 0%, transparent 100%)':''}">
                  <div style="position: absolute;color: white;font-size: 1vw;line-height: 1.5vw;font-family: test;letter-spacing: 1px;left: 0.5vw" :style="{color: managerShow!=='classroom'?'white':'black'}">班级详情</div>
                </div>
              </div>
            </div>

            <div class="under-line"></div>
          </div>

          <div v-if="managerShow==='classroom'" >
            <el-table ref="multipleTable"
                      :cell-style="{fontSize:'0.7vw',whiteSpace:'nowrap',height:'5vh'}"
                      :header-cell-style="{background:'rgb(229,229,229)',color:'rgb(144, 147, 153)',fontWeight:'600',height:'4vh'}"
                      :data="classTableData.filter(data => !searchClassroom || data.name.toLowerCase().includes(searchClassroom.toLowerCase()))"
                      tooltip-effect="dark"
                      border
                      center
                      fix
                      height="0"
                      class="scorll-table"
                      v-loading="loadingClassroomData"
                      element-loading-text="获取数据中"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      style="width: 90%;margin: 0 auto 0;min-height: 65vh;">
              <el-table-column type="selection"
                               width="55"
                               align="center"
                               v-if="0"></el-table-column>
              <el-table-column type="index"
                               label="序号"
                               width="60"
                               align="center"></el-table-column>
              <el-table-column prop="name"
                               label="班级"
                               align="center" >
                <template slot-scope="scope">
                  {{scope.row.name||scope.row['class_name']}}
                </template>
              </el-table-column>
              <el-table-column prop="status"
                               label="状态"
                               align="center" >
                <template slot-scope="scope">1</template>
              </el-table-column>
              <el-table-column align="center" min-width="200">
                <template slot="header"
                          slot-scope="scope">
                  <div v-if="user_type==='学校管理员'"style="display: flex;flex-wrap: nowrap;flex-direction: row;align-items: center;justify-content: center">
                    <div @click="addBtn=false"
                         style="height: 2.5vh;width: 4vh;border-right: 4px;line-height: 2.5vh;background-color: white"
                         v-if="addBtn"><i class="el-icon-plus"></i></div>
                    <div style="display: flex;flex-wrap: nowrap;flex-direction: row;align-items: center;height: 3vh;width: 85%"
                         v-else>
                      <span style="font-size: 0.6vw;white-space: nowrap" >班级名称：</span>
                      <input v-model="addClassroomName"
                             class="manage-input"
                             placeholder="年级+班级"></input>
                      <div @click="handleAdd('classroom')" style="height: 3vh;line-height: 3vh;white-space: nowrap" >提交</div>
                    </div>
                  </div>
                  <div v-else>
                    操作
                  </div>
                </template>
                <template slot-scope="scope">
                  <el-button type="text"
                             size="small"
                             v-if="user_type==='学校管理员'"
                             @click="openDia(scope.row,'classroom')">删除</el-button>
                  <el-button type="text"
                             size="small"
                             v-if="user_type==='学校管理员'"
                             @click="editClassroom('classroom',scope.row)">编辑</el-button>
                  <el-button type="text"
                             size="small"
                             @click="toStudentManager(scope.row)">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="class-pagination" >
              <el-pagination layout="prev, pager, next"
                             v-if="user_type==='学校管理员'"
                             :page-size="classroomPage.limit"
                             hide-on-single-page
                             @current-change="classPageChange($event,'classroom')"
                             :total="classroomPage.total">
              </el-pagination>
            </div>

          </div>

          <div v-show="managerShow==='student'">
            <el-table :data="studentTableData.filter(data => !searchClassroom || data.name.toLowerCase().includes(searchClassroom.toLowerCase()))"
                      :cell-style="{fontSize:'0.7vw',whiteSpace:'nowrap',height:'5vh'}"
                      :header-cell-style="{background:'rgb(229,229,229)',color:'rgb(144, 147, 153)',fontWeight:'600',height:'4vh'}"
                      tooltip-effect="dark"
                      border
                      center
                      v-loading="loadingStudentData"
                      element-loading-text="获取数据中"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      style="width: 90%;margin: 0 auto 0;overflow: auto">
              <el-table-column type="index"
                               label="序号"
                               width="60"
                               align="center"></el-table-column>
              <el-table-column prop="name"
                               label="姓名"
                               align="center"
                               :formatter="defaultData"></el-table-column>
              <el-table-column prop="number"
                               label="学号"
                               align="center"
                               :formatter="defaultData"></el-table-column>
              <el-table-column prop="user_id"
                               label="用户ID"
                               align="center"></el-table-column>
              <el-table-column label="操作"
                               align="center">
                <template slot-scope="scope">
                  <el-button type="text"
                             size="small"
                             @click="openDia(scope.row,'student')">删除</el-button>
                  <el-button type="text"
                             size="small"
                             @click="manageClassroomDialog=true;selectStudent=scope.row">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>

            <div class="class-pagination">
              <el-pagination layout="prev, pager, next"
                             :page-size="studentPage.limit"
                             hide-on-single-page
                             @current-change="classPageChange($event,'student')"
                             :total="studentPage.total">
              </el-pagination>
            </div>
          </div>

          <div v-show="managerShow==='teacher'">
            <el-table :data="teacherTableData.filter(data => !searchClassroom || data.name.toLowerCase().includes(searchClassroom.toLowerCase()))"
                      :cell-style="{fontSize:'0.7vw',whiteSpace:'nowrap',height:'5vh'}"
                      :header-cell-style="{background:'rgb(229,229,229)',color:'rgb(144, 147, 153)',fontWeight:'600',height:'4vh'}"
                      tooltip-effect="dark"
                      border
                      center
                      v-loading="loadingClassTeacherData"
                      element-loading-text="获取数据中"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      style="width: 90%;margin: 0 auto 0;overflow: auto">
              <el-table-column prop="user_id"
                               label="用户ID"
                               align="center"></el-table-column>
              <el-table-column prop="name"
                               label="姓名"
                               align="center"
                               :formatter="defaultData"></el-table-column>
              <el-table-column prop="number"
                               label="编号"
                               align="center"
                               :formatter="defaultData"></el-table-column>
              <el-table-column prop="is_manager"
                               label="类型"
                               align="center"
                               :formatter="isManager"></el-table-column>
              <el-table-column label="操作"
                               align="center"
                               width="300">
                <template slot-scope="scope">
                  <el-button type="text"
                             size="small"
                             @click="openDia(scope.row,'teacher')">删除</el-button>
                  <el-button type="text"
                             size="small"
                             @click="manageClassroomDialog=true;selectTeacher=scope.row">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>

            <div class="class-pagination">
              <!--              <el-pagination layout="prev, pager, next"-->
              <!--                             :page-size="teacherPage.limit"-->
              <!--                             hide-on-single-page-->
              <!--                             @current-change="classPageChange($event,'classroomTeacher')"-->
              <!--                             :total="teacherPage.total">-->
              <!--              </el-pagination>-->
            </div>

          </div>
        </div>



        <div v-show="applyActive"
             class="card-right">
          <div class="account-line">
            <div class="line-font">
              <div class="line-font-left" style="background-color: rgb(255, 212, 80)"></div>
              <div class="line-font-right" style="background-image: linear-gradient(90deg, rgb(255, 212, 80) 0%, transparent 100%);">
                <div style="position: absolute;color: white;font-size: 1vw;line-height: 1.5vw;font-family: test;letter-spacing: 1px;left: 0.5vw">申请加入</div>
              </div>
            </div>
            <div class="under-line"></div>
          </div>
          <div class="apply-form">
            <div class="apply-line">
              <span class="apply-label">姓名</span>
              <el-input v-model="applyForm.name"
                        style="width: 8vw;margin-right: 2vw"></el-input>

            </div>
            <div class="apply-line">
              <span class="apply-label">类型</span>
              <el-select v-model="applyForm.type"
                         placeholder="请选择"
                         style="width: 8vw;">
                <el-option label="老师"
                           value="teacher"></el-option>
                <el-option label="学生"
                           value="student"></el-option>
              </el-select>
            </div>
            <div class="apply-line"

                 v-if="user_type==='普通用户'||user_type==='管理员'">
              <span class="apply-label">所在学校</span>
              <el-select placeholder="省"
                         style="width: 8vw;margin-right: 0.7vw"
                         v-model="applyForm.province"
                         @change="provinceInput">
                <el-option v-for="item in province"
                           :key="item.province_code"
                           :label="item.province_name"
                           :value="JSON.stringify({name:item.province_name,code:item.province_code})">
                </el-option>
              </el-select>
              <el-select placeholder="市"
                         style="width: 8vw;margin-right: 0.7vw"
                         v-model="applyForm.city"
                         @change="cityChange"
              >
                <el-option v-for="item in city"
                           :key="item.city_code"
                           :label="item.city_name"
                           :value="JSON.stringify({name:item.city_name,code:item.city_code})">
                </el-option>
              </el-select>
              <el-select placeholder="区"
                         style="width: 8vw;margin-right:0.7vw"
                         @change="getSchoolList"
                         v-model="applyForm.area">
                <el-option v-for="item in area"
                           :key="item.county_code"
                           :label="item.county_name"

                           :value="JSON.stringify({name:item.county_name,code:item.county_code})">
                </el-option>
              </el-select>
              <el-select v-model="applyForm.school"
                         style="width: 8vw;margin-right: 0.7vw"
                         placeholder="学校">
                <el-option v-for="item in schoolList"
                           :key="item.school_code"
                           :label="item.school_name"
                           :value="JSON.stringify({name:item.school_name,code:item.school_code})">
                </el-option>
              </el-select>
            </div>
            <div class="apply-line"
                 v-if="user_type==='学生'||user_type==='管理员'">
              <span class="apply-label">班级</span>
              <el-select placeholder="班级"
                         style="width: 8vw"
                         v-model="applyForm.classroom">
                <el-option v-for="item in classroomList"
                           :key="item.id"
                           :label="item.name"
                           :value="JSON.stringify(item)">
                </el-option>
              </el-select>
            </div>
            <div class="apply-line" v-if="0">
              <span class="apply-label">申请内容</span>
              <el-input
                style="width: 34.1vw;border: none"
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                v-model="applyForm.content">
              </el-input>
            </div>
            <div class="apply-btn-line">
              <div type="primary"
                   @click="submitApply"
                   style="
                     margin: auto;
                     width: 6rem;
                     height: 1.5vw;
                     background-color: #5eb2f7;
                     border-radius: 4px;
                     line-height: 1.5vw;
                     cursor: pointer;
                     text-align: center;
                     color: white">发起申请</div>
            </div>
          </div>
        </div>


        <div v-show="reportActive" class="card-right">
          <div class="account-line" style="margin-top: 1vw;width: 95%;margin-bottom: 1vh">
            <div style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: flex-end;  height: 8vh;min-height: 40px;align-items: center;width: 100%;position: relative">
              <div class="line-font"  >
                <div class="line-font-left" :style="{backgroundColor:'rgb(255, 212, 80)'}"></div>
                <div class="line-font-right" :style="{backgroundImage:'linear-gradient(90deg, rgb(255, 212, 80) 0%, transparent 100%)'}">
                  <div style="position: absolute;color: white;font-size: 1vw;line-height: 1.5vw;font-family: test;letter-spacing: 1px;left: 0.5vw" >实验报告</div>
                </div>
              </div>

              <div class="report-action-btn" @click="bulkDownload" style="margin-left: auto;margin-right: 0.3vw">批量下载</div>
              <div class="report-action-btn" >删除</div>
              <input class="report-input" v-model="reportSearchInput"></input>
              <i v-if="reportSearchInput.length>0" class="el-icon-close" style="display: inline-block;font-size: 1.2vw;margin-right: 0.2vw;position: absolute;right:2vw" @click="reportSearchInput=''"></i>
              <i class="el-icon-search" style="display: inline-block;font-size: 1.2vw;margin-right: 0vw" ></i>
            </div>
            <div class="under-line"></div>
          </div>

          <div class="report-excel">
            <div style="width: 100%;white-space: nowrap;margin: 0 auto 0;height: 65vh;">
              <el-table
                :cell-style="{fontSize:'0.7vw',whiteSpace:'nowrap',height:'5vh'}"
                :header-cell-style="{background:'rgb(229,229,229)',color:'rgb(144, 147, 153)',fontWeight:'600',height:'4vh'}"
                ref="multipleTable"
                :data="reportList.filter(data => !reportSearchInput || data.name.toLowerCase().includes(reportSearchInput.toLowerCase()))"
                tooltip-effect="dark"
                style="width: 95%;white-space: nowrap;margin: 0 auto 0;height: 65vh;"
                @row-click="showImg"
                @selection-change="downloadSelect">
                <el-table-column type="selection" align="center" ></el-table-column>
                <el-table-column prop="name" label="实验名称" align="center" min-width="150"></el-table-column>
                <el-table-column prop="subject" label="科目" align="center"></el-table-column>
                <el-table-column prop="updated_at" label="保存时间" align="center" :formatter="reportTime"></el-table-column>
                <el-table-column  label="操作" align="center">
                  <template slot-scope="scope" >
                    <div style="display: flex;justify-content: center;align-items: center;flex-wrap: nowrap">
                      <div @click="downloadImg(scope.row)"  class="table-btn download-icon"></div>
                      <div  class="delete-btn" ></div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-pagination layout="prev, pager, next"
                           hide-on-single-page
                           style="display: flex;flex-wrap: nowrap;justify-content: center;align-items: center;margin-top: auto;width: 100%;height: 5vh;"
                           :page-size="reportPage.limit"
                           @current-change="classPageChange($event,'report')"
                           :total="reportPage.total">
            </el-pagination>
          </div>
        </div>



        <div v-show="logActive" class="card-right">
          <div class="account-line" style="margin-bottom: 0.5vw;margin-top: 1vw;width: 95%">
            <div style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: flex-end;  height: 8vh;min-height: 40px;align-items: center;width: 100%;position: relative">
              <div class="line-font" @click="switchPage('老师日志')">
                <div class="line-font-left" :style="{backgroundColor: activePage==='teacher'?'rgb(239, 101, 65)':'transparent'}"></div>
                <div class="line-font-right" :style="{backgroundImage:activePage==='teacher'?'linear-gradient(90deg, rgb(239, 101, 65) 0%, transparent 100%)':''}">
                  <div style="position: absolute;color: white;font-size: 1vw;line-height: 1.5vw;font-family: test;letter-spacing: 1px;left: 0.5vw" :style="{color: activePage==='teacher'?'white':'black'}">老师日志</div>
                </div>
              </div>
              <div class="line-font" @click="switchPage('学生日志')" >
                <div class="line-font-left" :style="{backgroundColor: activePage==='student'?'rgb(239, 101, 65)':'transparent'}"></div>
                <div class="line-font-right" :style="{backgroundImage:activePage==='student'?'linear-gradient(90deg, rgb(239, 101, 65) 0%, transparent 100%)':''}">
                  <div style="position: absolute;color: white;font-size: 1vw;line-height: 1.5vw;font-family: test;letter-spacing: 1px;left: 0.5vw" :style="{color: activePage==='student'?'white':'black'}">学生日志</div>
                </div>
              </div>
              <el-date-picker
                size="mini"
                style="border: none;width: 12vw;margin-left: auto;text-align: center"
                v-model="logDatePick"
                type="daterange"
                prefix-icon="el-icon-date"
                start-placeholder="开始"
                end-placeholder="结束">
              </el-date-picker>
              <input class="log-input" v-model="logNameSearch" >
              <i class="el-icon-close" style="display: inline-block;font-size: 0.9vw;margin-right: 0.2vw;position: absolute;right:0.5vw" @click="logNameSearch=''" v-if='logNameSearch.length>0'></i>



            </div>
            <div class="under-line"></div>
          </div>
          <el-table
            :cell-style="{fontSize:'0.7vw',whiteSpace:'nowrap',height:'4vh'}"
            :header-cell-style="{background:'rgb(229,229,229)',color:'rgb(144, 147, 153)',fontWeight:'600',height:'3.5vh'}"
            ref="multipleTable"
            :data="logList.filter(data => !logNameSearch || data['user_name']&&data['user_name'].toString().toLowerCase().includes(logNameSearch.toLowerCase()))"
            tooltip-effect="dark"
            style="width: 95%;white-space: nowrap;margin:0 auto 0;height: 66vh">
            <el-table-column type="index" label="序号" align="center" ></el-table-column>
            <el-table-column prop="user_id" label="用户ID" align="center" ></el-table-column>
            <el-table-column prop="user_name" label="用户" align="center" :formatter="defaultName"></el-table-column>
            <el-table-column prop="updated_at" label="时间" align="center" sortable :formatter="changeTime" width="250"></el-table-column>
            <el-table-column

              prop="log_type"
              label="类型"
              align="center"
              :filters="[{text: '登录', value: '登陆'},{text: '注册', value: 'signUp'},{text: '退出', value: 'leave'},{text: '同步实验', value: 'online'},{text: '模考', value: 'exam'}]"
              :filter-method="typeSelect"></el-table-column>
            <el-table-column prop="area" label="区域" align="center"  :formatter="changeZone"></el-table-column>
            <el-table-column prop="ip" label="IP地址" align="center"  ></el-table-column>
          </el-table>
          <el-pagination layout="prev, pager, next"
                         hide-on-single-page
                         style="display: flex;flex-wrap: nowrap;justify-content: center;align-items: center;margin-top: auto;width: 100%;height: 5vh;"
                         :page-size="logPage.limit"
                         @current-change="classPageChange($event,'log')"
                         :total="logPage.total">
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog :visible="dialogVisible!==0"
               :before-close="closeDia"
               width="30%"
               center
               :show-close="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <span slot="title"
            class="title">
        <span class="title-icon "
              :class="{'dialog-icon1':dialogVisible===1,'dialog-icon2':dialogVisible===2,'dialog-icon3':dialogVisible===3,'dialog-icon4':dialogVisible===4}"></span>
        <span class="dialog-title">{{actionList[dialogVisible-1]}}</span>
      </span>
      <div v-if="dialogVisible===4">
        <input v-model="dialogInput[0]"
               v-if="dialogVisible!==0&&dialogVisible!==3"
               placeholder="请输入手机号/邮箱"
               class="dialog-input"></input>
        <input v-model="dialogInput[1]"
               v-if="dialogVisible!==0&&dialogVisible!==3"
               placeholder="请输入验证码"
               class="dialog-input"
               style="width: 10vw"></input>
        <el-button v-if="dialogVisible!==0&&dialogVisible!==3"
                   @click="getCode"
                   :disabled="hasSend">{{code_msg}}</el-button>
        <input v-model="dialogInput[2]"
               v-if="dialogVisible!==0&&dialogVisible===4"
               placeholder="请输入新密码"
               class="dialog-input"></input>
        <input v-model="dialogInput[3]"
               v-if="dialogVisible!==0&&dialogVisible===4"
               placeholder="请确认密码"
               class="dialog-input"></input>
      </div>
      <div v-else>
        <span>功能待开放...</span>
      </div>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible=0">取消</el-button>
        <el-button type="primary"
                   @click="handleBind">确定</el-button>
      </span>

    </el-dialog>

    <el-dialog :visible.sync="manageSchoolDialog"
               title="管理"
               center>
      <p>班级：{{selectClassroom.name}}</p>
      <p>ID:{{selectClassroom.id}}</p>
      <p>班主任：{{selectClassroom['manager_id']||'暂无'}}</p>
      <el-table tooltip-effect="dark"
                border
                center
                v-loading="loadingTeacherData"
                element-loading-text="获取数据中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                :data="schoolTeacherList">
        <el-table-column type="index"
                         width="60"
                         label="序号"></el-table-column>
        <el-table-column prop="name"
                         label="姓名"
                         :formatter="defaultData"></el-table-column>
        <el-table-column prop="number"
                         label="编号"
                         :formatter="defaultData"></el-table-column>
        <el-table-column prop="user_id"
                         label="用户ID"></el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <el-button type="text"
                       size="small"
                       @click="setClassroomManager(scope.row,'manager')">设为班主任</el-button>
            <el-button type="text"
                       size="small"
                       @click="setClassroomManager(scope.row,'normal')">设为普通老师</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="class-pagination">
        <el-pagination layout="prev, pager, next"
                       :page-size="schoolTeacherPage.limit"
                       hide-on-single-page
                       @current-change="classPageChange($event,'schoolTeacher')"
                       :total="schoolTeacherPage.total">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog :visible="manageClassroomDialog"
               title="管理"
               center
               :show-close="false"
               width="30%">
      <div style="width: 20vw;margin: auto;font-size: 0.7vw;">
        <!--        <span>{{selectClassroom.name}}</span>-->
        <div class="line-input">
          <span class="dialog-label">班级：</span>
          <input :value="selectClassroom.name" style="color:gray;height: 1.5vw;margin-top: 0;cursor: not-allowed;width: 14vw" :disabled="true"></input>
        </div>
        <div class="line-input">
          <span class="dialog-label">用户ID：</span>
          <input :value="user_type==='学校管理员'?selectTeacher.user_id:selectStudent.id" style="color:gray;height: 1.5vw;margin-top: 0;cursor: not-allowed;width: 14vw" :disabled="true"></input>
        </div>
        <div class="line-input">
          <span class="dialog-label">姓名：</span>
          <input style="height: 1.5vw;margin-top: 0;width: 14vw" v-if="user_type==='学校管理员'" :placeholder="user_type==='学校管理员'?(selectTeacher.name||'暂无'):(selectStudent.name||'暂无')"
                 v-model="changeTeacher.name"></input>
          <input style="height: 1.5vw;margin-top: 0;width: 14vw" v-else
                 :placeholder="user_type==='学校管理员'?(selectTeacher.name||'暂无'):(selectStudent.name||'暂无')"
                 v-model="changeStudent.name"></input>
        </div>
        <div class="line-input">
          <span class="dialog-label">编号：</span>
          <input style="height: 1.5vw;margin-top: 0;width: 14vw" v-if="user_type==='学校管理员'" :placeholder="user_type==='学校管理员'?(selectTeacher.number||'暂无'):(selectStudent.number||'暂无')"
                 v-model="changeTeacher.number"></input>
          <input style="height: 1.5vw;margin-top: 0;width: 14vw" v-else
                 :placeholder="user_type==='学校管理员'?(selectTeacher.number||'暂无'):(selectStudent.number||'暂无')"
                 v-model="changeStudent.number"></input>
        </div>
      </div>

      <span slot="footer">
        <el-button @click="editStudent">确认</el-button>
        <el-button @click="manageClassroomDialog=false">取消</el-button>
      </span>
    </el-dialog>


    <el-dialog :visible="showImgVisible"
               title="实验报告"
               center
               top="50px"
               :show-close="false"
               fullscreen>
      <img :src="imgSrc" width="100%" alt="图片已损坏">
      <span slot="footer">
        <el-button @click="showImgVisible=false">确认</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible="logout"
               width="30%"
               title="警告">
      <span>确认退出吗？当前未保存的操作将全部失效！！！</span>
      <template slot="footer">
        <el-button @click="logout=false">取消</el-button>
        <el-button @click="logOut">确认</el-button>
      </template>
    </el-dialog>

    <div style="width: 100vw;height: 3vw;display: flex;margin: 0"></div>

  </div>
</template>

<script>
import NavHeader from '@/components/NavHeader'
import Footer from '@/components/Footer'
import tabTitle from '@/components/tabTitle'
import { mapGetters } from 'vuex'
import {getProvince, getCity, getArea, getSchool, getLogList} from '@/api/user'
import {getHistory, getCollect, getReportList} from '@/api/app'
import routerList from '@/components/routerList'
import reviewCard from '@/components/reviewCard'
import crumbBread from '@/components/crumbBread'
import {
  addClassroom,
  addStudent,
  addStudentToClassroom,
  addTeacherToClassroom,
  deleteClassroom,
  deleteStudentFormClassroom, deleteTeacherFormClassroom, editManagerToClassroom,
  editStudentInfo, editTeacherMessage,
  getAdminId,
  getClassroomList,
  getClassroomStudentList,
  getClassroomTeacherList,
  getSchoolTeacherList,
  getTeacherClassroomList,
  setManagerToClassroom
} from '@/api/school'
import {getMessageCount, sendApply} from '@/api/message'
import AppCard from '@/components/AppCard'
import $ from 'jquery'
import routerList_desktop from "@/components/routerList_desktop";
import {getToken} from "@/utils/auth";
const picWidth = 1920
const picHeight = 1071
const date = new Date()
const devRouter = [
  {
    path: '/user_msg',
    icon: '/home/p__基本资料大icon',
    label: '基本信息',
    title: 'account',
    active: false,
    auth: '2',
  },
  {
    path: '/safe',
    icon: '/home/p__账户安全大icon',
    label: '账号安全',
    title: 'safe',
    active: false,
    auth: '2'
  },
  {
    path: '/app',
    icon: '/home/p__我的实验大icon',
    label: '我的实验',
    title: 'app',
    active: false,
    auth: '3,4,6'
  },
  // {
  //   path: '/review',
  //   icon: '/home/回放',
  //   label: '实验回放',
  //   title: 'review',
  //   active: false,
  //   auth: '4,6',
  // },
  {
    path: 'manager',
    icon: '/home/班级管理',
    label: "班级管理",
    title: "manager",
    active: false,
    auth: '6'
  },
  {
    path: 'apply',
    icon: '/home/班级管理',
    label: "申请学校",
    title: "apply",
    active: false,
    auth: '2'
  },
  {
    path: 'report',
    icon: '/home/班级管理',
    label: "实验报告",
    title: "report",
    active: false,
    auth: '2'
  },
  {
    path: 'log',
    icon: '/home/log',
    label: "操作日志",
    title: "log",
    active: false,
    auth: '6'
  }
]


const customRouter = [
  {
    path: '/user_msg',
    icon: '/home/p__基本资料大icon',
    label: '基本信息',
    title: 'account',
    active: false,
    auth: '2',
  },
  {
    path: '/safe',
    icon: '/home/p__账户安全大icon',
    label: '账号安全',
    title: 'safe',
    active: false,
    auth: '2'
  },
  {
    path: 'apply',
    icon: '/home/班级管理',
    label: "申请学校",
    title: "apply",
    active: false,
    auth: '2'
  }
]


const studentRouter = [
  {
    path: '/user_msg',
    icon: '/home/p__基本资料大icon',
    label: '基本信息',
    title: 'account',
    active: false,
    auth: '2',
  },
  {
    path: '/safe',
    icon: '/home/p__账户安全大icon',
    label: '账号安全',
    title: 'safe',
    active: false,
    auth: '2'
  },
  {
    path: '/app',
    icon: '/home/p__我的实验大icon',
    label: '我的实验',
    title: 'app',
    active: false,
    auth: '3,4,6'
  },
  {
    path: 'apply',
    icon: '/home/班级管理',
    label: "申请班级",
    title: "apply",
    active: false,
    auth: '2'
  },
  {
    path: 'report',
    icon: '/home/班级管理',
    label: "实验报告",
    title: "report",
    active: false,
    auth: '2'
  }
]


const teacherRouter = [
  {
    path: '/user_msg',
    icon: '/home/p__基本资料大icon',
    label: '基本信息',
    title: 'account',
    active: false,
    auth: '2',
  },
  {
    path: '/safe',
    icon: '/home/p__账户安全大icon',
    label: '账号安全',
    title: 'safe',
    active: false,
    auth: '2'
  },
  {
    path: '/app',
    icon: '/home/p__我的实验大icon',
    label: '我的实验',
    title: 'app',
    active: false,
    auth: '3,4,6'
  },
  // {
  //   path: '/review',
  //   icon: '/home/回放',
  //   label: '实验回放',
  //   title: 'review',
  //   active: false,
  //   auth: '4,6',
  // },
  {
    path: 'manager',
    icon: '/home/班级管理',
    label: "班级管理",
    title: "manager",
    active: false,
    auth: '6'
  },
  {
    path: 'report',
    icon: '/home/班级管理',
    label: "实验报告",
    title: "report",
    active: false,
    auth: '2'
  }
]


const managerRouter = [
  {
    path: '/user_msg',
    icon: '/home/p__基本资料大icon',
    label: '基本信息',
    title: 'account',
    active: false,
    auth: '2',
  },
  {
    path: '/safe',
    icon: '/home/p__账户安全大icon',
    label: '账号安全',
    title: 'safe',
    active: false,
    auth: '2'
  },
  {
    path: '/app',
    icon: '/home/p__我的实验大icon',
    label: '我的实验',
    title: 'app',
    active: false,
    auth: '3,4,6'
  },
  // {
  //   path: '/review',
  //   icon: '/home/回放',
  //   label: '实验回放',
  //   title: 'review',
  //   active: false,
  //   auth: '4,6',
  // },
  {
    path: 'manager',
    icon: '/home/班级管理',
    label: "班级管理",
    title: "manager",
    active: false,
    auth: '6'
  },
  {
    path: 'log',
    icon: '/home/log',
    label: "操作日志",
    title: "log",
    active: false,
    auth: '6'
  }
]




export default {
  layout: 'home',
  name: 'home_desktop',
  components: {
    AppCard,
    NavHeader,
    Footer,
    tabTitle,
    reviewCard,
    crumbBread,
    routerList_desktop
  },
  computed: {
    ...mapGetters([
      'user_privacy',
      'person_msg'
    ])
  },
  created () {
      let group = JSON.parse(sessionStorage.getItem('user_type'))
      try{
        if (group.find(item => item.name === '普通用户')) {
          this.user_type = '普通用户'
          this.routerlist = customRouter
        }
        if (group.find(item => item.name === '家长')) {
          this.user_type = '家长'
          this.routerlist = customRouter
        }
        if (group.find(item => item.name === '老师')) {
          this.user_type = '老师'
          this.routerlist = teacherRouter
        }
        if (group.find(item => item.name === '学生')) {
          this.user_type = '学生'
          this.routerlist = studentRouter
        }
        if (group.find(item => item.name === '学校管理员')) {
          this.user_type = '学校管理员'
          this.routerlist = managerRouter
        }
        if (group.find(item => item.name === '管理员')) {
          this.user_type = '管理员'
          this.routerlist = devRouter
        }
        sessionStorage.setItem('user_identity', this.user_type)
        sessionStorage.setItem('router', JSON.stringify(this.routerlist))
        this.loginUid=sessionStorage.getItem('uid')
        this.loginAccount=sessionStorage.getItem('account')
        console.log(sessionStorage.getItem('uid'))
        if(this.$route.query.rightPage==='app'){
          getHistory(this.activeselDate, this.historypage.page, this.historypage.limit).then(res => {
            if (res.status === 'ok') {
              this.historypage.page = res.page.current_page
              this.historypage.total = res.page.total
              this.historypage.limit = res.page.per_page
              this.historyCardList = res.data
            }
          })
        }
      }
      catch (e) {
        console.log(e)
      }
  },
  mounted () {

    getMessageCount().then(res => {
      if (res.status === 'ok') {
        this.messageCount = res.data['unread_counter']
      }
      else {
        if (getToken()) {
          this.$message.warning('暂时无法获取消息通知')
        }
      }

    })
    this.platform=sessionStorage.getItem('platform')
    window.addEventListener('resize',()=>{
      this.appWidth=window.innerWidth/100*8
    })

    let group = JSON.parse(sessionStorage.getItem('user_type'))

    if (group.find(item => item.name === '普通用户')) {
      this.user_type = '普通用户'
      this.routerlist = customRouter
    }
    if (group.find(item => item.name === '家长')) {
      this.user_type = '家长'
      this.routerlist = customRouter
    }
    if (group.find(item => item.name === '老师')) {
      this.user_type = '老师'
      this.routerlist = teacherRouter
    }
    if (group.find(item => item.name === '学生')) {
      this.user_type = '学生'
      this.routerlist = studentRouter
    }
    if (group.find(item => item.name === '学校管理员')) {
      this.user_type = '学校管理员'
      this.routerlist = managerRouter
    }
    if (group.find(item => item.name === '管理员')) {
      this.user_type = '管理员'
      this.routerlist = devRouter
    }

    sessionStorage.setItem('user_identity', this.user_type)
    sessionStorage.setItem('router', JSON.stringify(this.routerlist))
    this.loginUid=sessionStorage.getItem('uid')
    this.loginAccount=sessionStorage.getItem('account')
    console.log(sessionStorage.getItem('uid'))
    this.formData.sex = this.person_msg.sex
    // $('img')['0'].hidden = true
    // $('img')['0'].height = $('.whole-page')['0'].clientHeight
    // $('img')['0'].hidden = false
    if (this.$route.query.rightPage) {
      this.accountActive = false
      this.safeActive = false
      this.appActive = false
      this.reviewActive = false
      this.managerActive = false
      this[this.$route.query.rightPage + 'Active'] = true
    }
    this.uid=sessionStorage.getItem('uid')
    this.$fetch()

    this.formData.school = this.person_msg.school || sessionStorage.getItem('school')
    this.formData.province = this.person_msg.local.province || sessionStorage.getItem('province')
    this.formData.city = this.person_msg.local.city || sessionStorage.getItem('city')
    this.formData.area = this.person_msg.local.area || sessionStorage.getItem('area')
  },
  fetch () {
    getProvince().then(res => {

      this.province = res.data
    })

    getClassroomList(1, 300).then(res => {

      if (res.status === 'ok') {
        this.classroomList = res.data
        getTeacherClassroomList(this.uid).then(res1 => {

          if (res1.status === 'ok') {
            console.log(res1.data)
            console.log(res.data)
            for(let i=0;i<res.data.length;i++){
              for(let j=0;j<res1.data.length;j++){
                if(res1.data[j].class_id===res.data[i].id){
                  this.teacherClassroomList.push(res.data[i])
                }
              }

            }
          }
        })
      }
    })

  },
  data () {
    return {
      //获取地区学校
      logout:false,
      messageCount:'',
      platform:'',
      showCard:false,
      logDatePick:'',
      reportSearchInput:'',
      imgSrc:'',
      logActive:false,
      logList:[],
      logPage:{
        page:1,
        total:0,
        limit:15
      },
      logNameSearch:'',
      showImgVisible:false,
      clickDownload:false,
      clickDelete:false,
      province: [],
      city: [],
      appWidth:'',
      area: [],
      uid:'',
      reportList:[],
      reportPage:{
        page:1,
        total:0,
        limit:12
      },
      cityLoading: true,
      provinceLoading: true,
      areaLoading: true,
      searchClassroom: '',
      searchTeacher: '',
      ////////////////////////
      activeRouterBtn: this.$route.query.rightPage || 'account',
      selectList: [],
      loadingClassroomData: true,
      loadingClassTeacherData: true,
      teacherTableData: [],

      ///////////分页管理///////////
      classroomPage: {
        total: 0,
        page: 1,
        limit: 12
      },
      teacherPage: {
        total: 0,
        page: 1,
        limit: 12
      },
      studentPage: {
        total: 0,
        page: 1,
        limit: 12
      },
      schoolTeacherPage: {
        limit: 8,
        page: 1,
        total: 0
      },
      historypage: {
        total: 0,
        page: 1,
        limit: 6
      },
      collectionpage: {
        total: 0,
        page: 1,
        limit: 6
      },
      ////////////筛选选项///////////
      reviewList: [
        {
          pic: '',
          endTime: date.getFullYear() + '-' + date.getMonth() + '-' + date.getDay() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds(),
          count: 12,
          total: 40,
          title: '123456',
          classID: ''
        },
      ],
      subjectList: [
        { name: '小学科学', id: 1, active: false },
        { name: '初中物理', id: 2, active: false },
        { name: '初中化学', id: 3, active: false },
        { name: '初中生物', id: 4, active: false },
      ],
      versionList: [
        { name: '人教版', id: 1, active: false },
        { name: '粤教版', id: 2, active: false },
        { name: '北师大版', id: 3, active: false },
        { name: '鲁教版', id: 4, active: false },
        { name: '苏教版', id: 5, active: false },
        { name: '沪教版', id: 6, active: false }
      ],
      gradeList: [
        { name: '七年级', id: 7, active: false },
        { name: '八年级', id: 8, active: false },
        { name: '九年级', id: 9, active: false }
      ],
      dateList: [
        { label: '全部', date: 65536 },
        { label: '最近七天', date: 7 },
        { label: '最近一个月', date: 30 },
        { label: '最近半年', date: 180 },
      ],
      changeTeacher: {
        name: '',
        number: ''
      },
      //////////////////////////////
      studentTableData: [],
      loadingStudentData: true,
      loadingTeacherData: true,
      classTableData: [],
      code_msg: '获取验证码',
      selectAll: false,
      dialogVisible: 0,
      classID: '',
      user_type: '',
      studentName: '',
      managerShow: 'classroom',
      dialogInput: ['', '', '', ''],
      actionList: ['绑定手机', '绑定邮箱', '绑定微信', '设置密码'],
      appName: '',
      tags: {
        subject: '',
        grade: '',
        publisher: ''
      },


      studentList: [],
      routerlist: [],
      teacherClassroomList: [],
      classroomList:[],
      formData: {
        username: '',
        sex: '',
        province: '',
        city: '',
        area: '',
        school: '',
        classroom: ''
      },
      applyForm: {
        province: '',
        name: '',
        city: '',
        area: '',
        school: '',
        type: '',
        classroom: '',
        content:''
      },

      downloadList:[],
      reviewShow: 'classroom',
      activeselDate: 65536,
      historyCardList: [],
      collectCardList: [],
      activePage: 'history',
      manageSchoolDialog: false,
      accountActive: true,
      safeActive: false,
      appActive: false,
      reviewActive: false,
      managerActive: false,
      applyActive: false,
      reportActive:false,
      router: [
        { name: '首页', path: '/', disable: false },
        { name: '个人中心', path: '', disable: true },
        { name: '基本信息', path: '/home', disable: false }
      ],
      schoolList: [],
      schoolTeacherList: [],

      times: 60,
      timer: null,
      hasSend: false,
      phoneNumber: /^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/,
      email: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
      selectClassroom: '',
      selectStudent: '',
      selectTeacher: '',
      addBtn: true,
      manageClassroomDialog: false,
      addClassroomName: '',
      addStudentName: '',
      changeStudent: {
        name: '',
        number: ''
      }
    }
  },
  watch: {
    times: function () {
      if (this.times == 0) {
        clearInterval(this.timer)
        this.$nextTick(() => {
          this.code_msg = '重新发送'
          this.hasSend = false
        })
      }
      this.code_msg = '已发送' + this.times
    },
    managerActive: function () {
      if (this.managerActive === true) {
        if(this.user_type==='学校管理员'){
          getClassroomList(1, this.classroomPage.limit).then(res => {
            if (res.status === 'ok') {
              this.classroomPage.total = res.page.total
              this.classroomPage.page = res.page.current_page
              this.classTableData = res.data
              setTimeout(() => {
                this.loadingClassroomData = false
              }, 500)
            }
            else {
              setTimeout(() => {
                this.loadingClassroomData = false
              }, 500)
            }
          })
        }
        else{
          getTeacherClassroomList(sessionStorage.getItem('uid')).then(res=>{
            if (res.status === 'ok') {
              this.classroomPage.total = res.data.length
              this.classroomPage.page = 1
              this.classTableData = res.data
              setTimeout(() => {
                this.loadingClassroomData = false
              }, 500)
            }
            else {
              setTimeout(() => {
                this.loadingClassroomData = false
              }, 500)
            }
          })
        }

      }
      else {
        this.loadingClassroomData = true
      }
    },
    managerShow: function () {
      if (this.managerShow === 'classroom') {
        this.loadingStudentData = true
        this.loadingTeacherData = true
        this.loadingClassTeacherData = true
      }
    }
  },
  methods: {
    addTag (name) {
      if (this.gradeList.findIndex(item => item.name === name) !== -1) {
        if (this.tags.grade === name) {
          this.tags.grade = ''
        }
        else {
          this.tags.grade = name
        }

      }
      else if (this.subjectList.findIndex(item => item.name === name) !== -1) {
        if (this.tags.subject === name) {
          this.tags.subject = ''
        }
        else {
          this.tags.subject = name
        }
      }
      else if (this.versionList.findIndex(item => item.name === name) !== -1) {
        if (this.tags.publisher === name) {
          this.tags.publisher = ''
        }
        else {
          this.tags.publisher = name
        }
      }
      for (let i = 0; i < this.gradeList.length; i++) {
        if (this.gradeList[i].name !== this.tags.grade) {
          this.gradeList[i].active = false
        }
        else {
          this.gradeList[i].active = true
        }
      }
      for (let i = 0; i < this.versionList.length; i++) {
        if (this.versionList[i].name !== this.tags.publisher) {
          this.versionList[i].active = false
        }
        else {
          this.versionList[i].active = true
        }
      }
      for (let i = 0; i < this.subjectList.length; i++) {
        if (this.subjectList[i].name !== this.tags.subject) {
          this.subjectList[i].active = false
        }
        else {
          this.subjectList[i].active = true
        }
      }

      let select = ''
      if (this.tags.subject) {
        select += ('&subject=' + this.tags.subject)
      }
      else if (this.tags.grade) {
        select += ('&grade=' + this.tags.grade)
      }
      else {
        select += ('&publisher=' + this.tags.publisher)
      }
      getCollect(this.collectionpage.page, this.collectionpage.limit, select).then(res => {
        if (res.status === 'ok') {
          console.log(res)
          this.collectionpage.page = res.page.current_page
          this.collectionpage.total = res.page.total
          this.collectCardList = res.data
        }
      })
    },


    toStudentManager (row) {
      if (this.user_type === '老师') {
        getTeacherClassroomList(sessionStorage.getItem('uid')).then(res => {
          console.log(res)
          if (res.status === 'ok') {
            // res.data.find(item => item['class_id'] === row.id) && res.data.find(item => item['class_id'] === row.id)['is_manager'] === true
            //班级管理班主任限制条件
            this.selectClassroom = row
            getClassroomStudentList(1, this.studentPage.limit, row.id||row.class_id).then(res => {
              if (res.status === 'ok') {
                this.studentPage.page = res.page.current_page
                this.studentPage.total = res.page.total
                this.studentTableData = res.data
              }
            })
            setTimeout(() => {
              this.loadingStudentData = false
            }, 500)
            this.managerShow = 'student'
          }
          else {
            this.$message.error('网络错误，请稍后重试')
          }
        })
      }
      else {
        this.selectClassroom = row
        getClassroomTeacherList(row.id).then(res => {
          if (res.status === 'ok') {
            this.teacherTableData = res.data

          }
        })
        setTimeout(() => {
          this.loadingClassTeacherData = false
        }, 500)
        this.managerShow = 'teacher'
      }
    },


    defaultData (row, column) {
      if (row[column.property] === null) {
        return '暂无'
      }
      else return row[column.property]
    },


    isManager (row, column) {
      if (row[column.property] === false) {
        return '普通老师'
      }
      else return '班主任'
    },


    provinceInput (select) {
      // let code=this.province.find(item=>item["province_name"]===select)['province_code']
      getCity(JSON.parse(select).code).then(res => {
        console.log(res)
        this.city = res.data
      })
    },
    cityChange (select) {
      //let code=this.city.find(item=>item["city_name"]===select)['city_code']
      getArea(JSON.parse(select).code).then(res => {
        console.log(res)
        this.area = res.data
      })
    },
    // cityFocus () {
    //   if (JSON.parse(this.applyForm.province).name.length <= 0) {
    //     this.$message.error('请先选择省份')
    //   }
    // },
    getSchoolList (title) {
      //let code=this.area.find(item=>item["county_name"]===title)['county_code']
      getSchool(JSON.parse(title).code).then(res => {
        console.log(res)
        this.schoolList = res.data
      })
    },


    changeRight (title) {
      console.log(title)
      this.managerActive = false
      this.safeActive = false
      this.appActive = false
      this.accountActive = false
      this.reviewActive = false
      this.applyActive = false
      this.reportActive=false
      this.logActive=false
      this.activeRouterBtn = title
      this[title + 'Active'] = true
      if(title==='log'){
        this.activePage='teacher'
        this.logList=[]
        this.logNameSearch=''
        this.logDatePick=''
        this.logPage.page=1
        this.logPage.total=0
        let type=''
        if(this.activePage==='teacher'){
          type='老师'
        }
        if(this.activePage==='student'){
          type='学生'
        }
        getLogList(this.logPage.page,this.logPage.limit,type).then(res=>{
          if(res.status==='ok'){
            this.logPage.page=res.page.current_page
            this.logPage.total=res.page.total
            this.logList=res.data
          }
        })
      }

      if (title === 'app') {
        this.activePage='history'
        console.log(123)
        getHistory(this.activeselDate, this.historypage.page, this.historypage.limit).then(res => {
          if (res.status === 'ok') {
            this.historypage.page = res.page.current_page
            this.historypage.total = res.page.total
            this.historypage.limit = res.page.per_page
            this.historyCardList = res.data
          }
        })
      }
      if(title==='report'){
        getReportList(this.reportPage.page,this.reportPage.limit).then(res=>{
          if(res.status==='ok'){
            this.reportPage.page=res.page.current_page
            this.reportPage.total=res.page.total
            this.reportList=res.data
          }
        })
      }
    },
    logOut () {
      this.$store.dispatch('User/logout')
      this.logout = false
      sessionStorage.clear()
      window.close()
      // setTimeout(() => {
      //
      //   if (this.$route.path !== '/') {
      //     this.$router.push('/')
      //   }
      //   else {
      //     this.$router.go(0);
      //   }
      // }, 500)
    },
    moreText(row){
      // return row.name.length>12
    },
    reportTime(row,column){
      let date=new Date(row['updated_at'])

      let str=date.getFullYear()+'-'+(parseInt(date.getMonth())+1)+'-'+date.getDate()+' '+date.getHours()+':'+date.getMinutes()+':'+date.getSeconds()
      return str
    },
    downloadURL(imgUrl,name){
      var x = new XMLHttpRequest();
      x.open("GET",imgUrl, true);
      x.responseType = 'blob';
      x.onload=function(e) {
        var url = window.URL.createObjectURL(x.response)
        var a = document.createElement('a');
        a.href = url
        a.download = name;
        a.click()
      }
      x.send();
    },
    bulkDownload(){
      if(this.downloadList.length<=0){
        this.$message.warning('请先选择要下载的实验报告')
      }
      for(let i=0;i<this.downloadList.length;i++){
        this.downloadURL(this.downloadList[i].url,this.downloadList[i].name)
      }
    },
    downloadSelect(selection){
      console.log(selection)
      for(let i=0;i<selection.length;i++){
        let data={
          url:selection[i]['report_img_url'],
          name:selection[i].name+'.jpg'
        }
        if(this.downloadList.findIndex(item=>item.url===data.url)==-1){
          this.downloadList.push(data)
        }

      }
    },
    showImg(row,column,event){
      //console.log(row,column,event)
      if(column.label!=='操作'){
        // this.$axios.get(row["report_img_url"],{
        //   setHeaders:{
        //     responseType:'blob'
        //   }
        // }).then(res=>{
        //   console.log(res)
        //   let blob = new Blob([res.data],  {type: 'image/jpeg'});
        //   var blobToBase64=function(blob, callback) {
        //     var a = new FileReader();
        //     a.onload = function(e) {
        //       callback(e.target.result);
        //     }
        //     a.readAsDataURL(blob);
        //   };
        //   blobToBase64(blob,(data)=>{
        //     console.log(data)
        //   })
        //
        // })
        this.imgSrc= row["report_img_url"]
        this.showImgVisible=true

      }
    },
    getBase64(blob) {

      return new Promise((resolve, reject) => {

        const reader = new FileReader();

        reader.readAsDataURL(blob);

        reader.onload = () => resolve(reader.result);

        reader.onerror = error => reject(error);

      });

    },
    downloadImg(row){
      this.downloadURL(row["report_img_url"],row.name+'.png')
    },
    historyPaginationChange (page) {
      this.historypage.page = page
      getHistory(this.activeselDate, this.historypage.page, this.historypage.limit).then(res => {
        if (res.status === 'ok') {
          this.historypage.page = res.page.current_page
          this.historypage.total = res.page.total
          this.historypage.limit = res.page.per_page
          this.historyCardList = res.data
        }
      })
    },


    collectPaginationChange (page) {
      this.collectionpage.page = page
      let select = ''
      if (this.tags.subject) {
        select += ('&subject=' + this.tags.subject)
      }
      else if (this.tags.grade) {
        select += ('&grade=' + this.tags.grade)
      }
      else {
        select += ('&publisher=' + this.tags.publisher)
      }
      if (select === '') {
        getCollect(this.collectionpage.page, this.collectionpage.limit).then(res => {
          if (res.status === 'ok') {
            console.log(res)
            this.collectionpage.page = res.page.current_page
            this.collectionpage.total = res.page.total
            this.collectCardList = res.data
          }
        })
      }
      else {
        getCollect(this.collectionpage.page, this.collectionpage.limit, select).then(res => {
          if (res.status === 'ok') {
            console.log(res)
            this.collectionpage.page = res.page.current_page
            this.collectionpage.total = res.page.total
            this.collectCardList = res.data
          }
        })
      }

    },


    switchPage (page) {
      console.log(page)
      if (page === '历史实验') {
        this.activePage = 'history'
      }
      if(page==='我的收藏') {
        this.activePage = 'collection'
        console.log(this.collectionpage.page)
        getCollect(this.collectionpage.page||1, this.collectionpage.limit).then(res => {
          if (res.status === 'ok') {
            console.log(res)
            this.collectionpage.page = res.page.current_page
            this.collectionpage.total = res.page.total
            this.collectCardList = res.data
            console.log(this.collectionpage)
          }
        })

      }
      if(page==='老师日志'){
        this.activePage = 'teacher'
        this.logList=[]
        this.logNameSearch=''
        this.logDatePick=''
        this.logPage.page=1
        this.logPage.total=0
        let type=''
        if(this.activePage==='teacher'){
          type='老师'
        }
        if(this.activePage==='student'){
          type='学生'
        }
        getLogList(this.logPage.page,this.logPage.limit,type).then(res=>{
          if(res.status==='ok'){
            this.logPage.page=res.page.current_page
            this.logPage.total=res.page.total
            this.logList=res.data
          }
        })
      }
      if(page==='学生日志'){
        this.logList=[]
        this.logNameSearch=''
        this.logDatePick=''
        this.logPage.page=1
        this.logPage.total=0
        this.activePage = 'student'
        let type=''
        if(this.activePage==='teacher'){
          type='老师'
        }
        if(this.activePage==='student'){
          type='学生'
        }
        getLogList(this.logPage.page,this.logPage.limit,type).then(res=>{
          if(res.status==='ok'){
            this.logPage.page=res.page.current_page
            this.logPage.total=res.page.total
            this.logList=res.data
          }
        })
      }
    },

    selectDate (date) {
      this.$nextTick(() => {
        this.activeselDate = date
        getHistory(this.activeselDate, this.historypage.page, this.historypage.limit).then(res => {
          if (res.status === 'ok') {
            this.historypage.page = res.page.current_page
            this.historypage.total = res.page.total
            this.historypage.limit = res.page.per_page
            this.historyCardList = res.data
          }
        })
      })
    },

    submitFormData () {
      // console.log(this.formData)
      //
      // this.$store.dispatch('User/changePersonMsg',this.formData)
      // setTimeout(()=>{
      //   this.$notify({
      //     title: '成功',
      //     message: '信息修改成功',
      //     position: 'bottom-left',
      //     duration:3000,
      //     showClose:false,
      //     type:'success'
      //   });
      // },500)
    },


    closeDia () {
      this.dialogVisible = 0
    },


    showDialog (index) {
      this.dialogVisible = index + 1
    },


    getCode () {
      let email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      if (email.exec(this.dialogInput[0])) {

        this.$store.dispatch('User/getCodeChangePwd', this.dialogInput[0]).then((res) => {
          console.log(res)
          if (res.data.status = 'ok') {
            this.hasSend = true
            this.code_msg = '发送成功'
            this.timer = setInterval(() => {
              this.times--
            }, 1000)

          }
          else {
            this.$message.error('请输入合法邮箱或手机号')
          }
        }).catch((e) => {
          console.log(e)
        })
      }
      else {
        this.$message.error('请输入合法邮箱或手机号')
      }

    },


    submitApply () {
      if (this.applyForm.name && this.applyForm.type) {
        if (this.user_type === '普通用户') {
          let code = JSON.parse(this.applyForm.school).code
          getAdminId(code || 321123).then(res => {
            let message = {
              level: 3,
              title: JSON.stringify({
                action: 'join',
                target: 'school'
              }),
              content: JSON.stringify({
                name: this.applyForm.name,
                type: this.applyForm.type,
                targetName: this.applyForm.school
              }),
              to: 'user',
              filter: ''
            }
            if (res.status === 'ok') {
              message.filter = { id: res.data['manager_id'] }
              sendApply(message).then(res => {
                console.log(res)
                if (res.status === 'ok') {
                  this.$message.success('发送成功')
                }
                else {
                  this.$message.error('发送失败')
                }
              })
            }
            else {
              this.$message.error('该校暂无管理员')
            }
          })
        }
        else {
          let message = {
            level: 3,
            title: JSON.stringify({
              action: 'join',
              target: 'classroom'
            }),
            content: JSON.stringify({
              name: this.applyForm.name,
              type: this.applyForm.type,
              targetName: this.applyForm.classroom,
              targetData: this.applyForm.classroom
            }),
            to: 'user',
            filter: { id: JSON.parse(this.applyForm.classroom)['manager_id'] }

          }
          sendApply(message).then(res => {
            console.log(res)
            if (res.status === 'ok') {
              this.$message.success('发送成功')
            }
            else {
              this.$message.error('发送失败')
            }
          })
        }
      }
      else {
        this.$message.error('请完成申请表')
      }
    },


    editClassroom (type, row) {
      this.manageSchoolDialog = true
      if (type === 'classroom') {
        this.selectClassroom = row
        getSchoolTeacherList(this.schoolTeacherPage.page, this.schoolTeacherPage.limit).then(res => {
          if (res.status === 'ok') {
            this.schoolTeacherPage.page = res.page.current_page
            this.schoolTeacherPage.total = res.page.total
            this.schoolTeacherList = res.data

          }
          else {
            this.$message.error('获取失败')
          }
        })
        setTimeout(() => {
          this.loadingTeacherData = false
        }, 500)
      }
    },

    setClassroomManager (row, type) {
      if (type === 'manager') {
        if (this.selectClassroom['manager_id']) {
          let data = {
            name: this.selectClassroom.name,
            manager_id: row.user_id
          }
          editManagerToClassroom(data, this.selectClassroom.id).then(res => {
            if (res.status === 'ok') {
              this.$message.success('设置成功')
              this.manageSchoolDialog = false
              this.loadingClassroomData = true
              getClassroomList(this.classroomPage.page, this.classroomPage.limit).then(res => {
                if (res.status === 'ok') {
                  this.classroomPage.total = res.page.total
                  this.classroomPage.page = res.page.current_page
                  this.classTableData = res.data
                  setTimeout(() => {
                    this.loadingClassroomData = false
                  }, 500)
                }
                else {
                  setTimeout(() => {
                    this.loadingClassroomData = false
                  }, 500)
                }
              })
            }
            else {
              this.$message.error('设置失败')
              this.manageSchoolDialog = false
            }
          })
        }
        else {
          let data = {
            class_id: this.selectClassroom.id,
            user_id: row.user_id
          }
          setManagerToClassroom(data).then(res => {
            if (res.status === 'ok') {
              this.$message.success('设置成功')
              this.manageSchoolDialog = false
              this.loadingClassroomData = true
              getClassroomList(this.classroomPage.page, this.classroomPage.limit).then(res => {
                if (res.status === 'ok') {
                  this.classroomPage.total = res.page.total
                  this.classroomPage.page = res.page.current_page
                  this.classTableData = res.data
                  setTimeout(() => {
                    this.loadingClassroomData = false
                  }, 500)
                }
                else {
                  setTimeout(() => {
                    this.loadingClassroomData = false
                  }, 500)
                }
              })
            }
            else {
              this.$message.error('设置失败')
              this.manageSchoolDialog = false
            }
          })
        }
      }
      else {
        addTeacherToClassroom({ class_id: this.selectClassroom.id, user_id: row.user_id }).then(res => {
          if (res.status === 'ok') {
            this.$message.success('成功')
            this.manageSchoolDialog = false
            this.loadingClassroomData = true
            getClassroomList(this.classroomPage.page, this.classroomPage.limit).then(res => {
              if (res.status === 'ok') {
                this.classroomPage.total = res.page.total
                this.classroomPage.page = res.page.current_page
                this.classTableData = res.data
                setTimeout(() => {
                  this.loadingClassroomData = false
                }, 500)
              }
              else {
                setTimeout(() => {
                  this.loadingClassroomData = false
                }, 500)
              }
            })
          }
          else {
            this.$message.error('设置失败')
            this.manageSchoolDialog = false
          }
        })
      }
    },

    handleBind () {
      switch (this.dialogVisible) {
        case 1: {
          this.$nextTick(() => {
            this.dialogVisible = 0
          })

          break
        }
        case 2: {
          this.$nextTick(() => {
            this.dialogVisible = 0
          })
          break
        }
        case 3: {
          this.$nextTick(() => {
            this.dialogVisible = 0
          })
          break
        }
        case 4: {
          if ((this.dialogInput[2] !== this.dialogInput[3]) || (this.dialogInput[2].length <= 0)) {
            this.$message.error('请保持两次密码一致')
            break
          }
          else {
            if (this.dialogInput[1].length <= 0) {
              this.$message.error('请输入验证码')
              break
            }
            this.$store.dispatch('User/changePwd', {
              email: this.dialogInput[0],
              password: this.dialogInput[2],
              code: this.dialogInput[1]
            }).then(res => {
              if (res === 'ok') {
                this.$message.success('修改密码成功，请重新登录')
                this.$store.dispatch('User/logout')
                this.$router.push({
                  path: '/login',
                  query: {
                    way: '登录'
                  }
                })
              }
              else {
                this.$message.error('修改密码错误，请稍后重试')
              }
            }).catch(e => console.log(e))
            this.$nextTick(() => {

              this.dialogVisible = 0
            })
            break
          }

        }
      }
    },

    handleAdd (target) {
      this.addBtn = true
      if (target === 'classroom') {
        addClassroom({ name: this.addClassroomName }).then(res => {
          if (res.status === 'ok') {
            this.$message.success('ok')
          }
          else {
            this.$message.error('no')
          }
        })
        this.addClassroomName = ''
        this.loadingClassroomData = true
        getClassroomList(this.classroomPage.page, this.classroomPage.limit).then(res => {
          if (res.status === 'ok') {
            this.classroomPage.total = res.page.total
            this.classroomPage.page = res.page.current_page
            this.classTableData = res.data
            setTimeout(() => {
              this.loadingClassroomData = false
            }, 500)
          }
          else {
            setTimeout(() => {
              this.loadingClassroomData = false
            }, 500)
          }
        })
      }
      else {

      }
    },
    openApp (item) {
      console.log(item)
      this.$router.push({
        path: '/appInfo_desktop',
        query: {
          originPath:'/onlineApp_desktop',
          id: item.id||item.app_id,
          name: item.name,
          platform: sessionStorage.getItem('platform'),
        }
      })

    },
    editStudent () {
      if(this.user_type==='老师'){
        let data = {
          class_id: this.selectClassroom.class_id,
          user_id: this.selectStudent.user_id,
          name: this.changeStudent.name,
          number: this.changeStudent.number
        }
        editStudentInfo(data).then(res => {
          if (res.status === 'ok') {
            this.$message.success('成功')
            this.loadingStudentData = true
            getClassroomStudentList(this.studentPage.page, this.studentPage.limit, this.selectClassroom.class_id).then(res => {
              if (res.status === 'ok') {
                this.studentPage.page = res.page.current_page
                this.studentPage.total = res.page.total
                this.studentTableData = res.data
              }
            })
            setTimeout(() => {
              this.loadingStudentData = false
            }, 500)
          }
          else {
            this.$message.error('失败')
          }
        })
      }
      else{
        console.log(this.selectTeacher)
        let data = {
          user_id: this.selectTeacher.user_id,
          name: this.changeTeacher.name,
          number: this.changeTeacher.number
        }
        editTeacherMessage(data).then(res=>{
          if(res.status==='ok'){
            getClassroomTeacherList(this.selectClassroom.id).then(res => {
              if (res.status === 'ok') {
                this.teacherTableData = res.data
                this.$message.success('成功')
              }
            })
          }
        })
      }
      this.manageClassroomDialog = false
    },
    changeZone(row){
      return row.country+row.region+row.city
    },
    defaultName(row){
      if(!row['user_name']){
        return '未命名'
      }
      else return row['user_name']
    },
    utc2beijing(utc_datetime) {
      // 转为正常的时间格式 年-月-日 时:分:秒
      var T_pos = utc_datetime.indexOf('T');
      var Z_pos = utc_datetime.indexOf('Z');
      var year_month_day = utc_datetime.substr(0,T_pos);
      var hour_minute_second = utc_datetime.substr(T_pos+1,Z_pos-T_pos-1);
      var new_datetime = year_month_day+" "+hour_minute_second; // 2017-03-31 08:02:06

      // 处理成为时间戳
      timestamp = new Date(Date.parse(new_datetime));
      timestamp = timestamp.getTime();
      timestamp = timestamp/1000;

      // 增加8个小时，北京时间比utc时间多八个时区
      var timestamp = timestamp+8*60*60;

      // 时间戳转为时间
      var beijing_datetime = new Date(parseInt(timestamp) * 1000)

      return beijing_datetime; // 2017-03-31 16:02:06
    },
    changeTime(row,column){
      return this.utc2beijing(row['updated_at']).getFullYear()+
        '-'+(parseInt(this.utc2beijing(row['updated_at']).getMonth()+1))+
        '-'+this.utc2beijing(row['updated_at']).getDate()+
        ' '+this.utc2beijing(row['updated_at']).getHours()+
        ':'+this.utc2beijing(row['updated_at']).getMinutes()+
        ':'+this.utc2beijing(row['updated_at']).getSeconds()
    },
    typeSelect(value,row,column){

      console.log(value,row,column)
      return row['log_type']===value
    },
    classPageChange (page, target) {
      switch (target) {
        case 'classroom': {
          this.loadingClassroomData = true
          getClassroomList(page, this.classroomPage.limit).then(res => {
            if (res.status === 'ok') {
              this.classroomPage.total = res.page.total
              this.classroomPage.page = res.page.current_page
              this.classTableData = res.data
              setTimeout(() => {
                this.loadingClassroomData = false
              }, 500)
            }
            else {
              setTimeout(() => {
                this.loadingClassroomData = false
              }, 500)
            }
          })
          break
        }
        case 'schoolTeacher': {
          this.loadingTeacherData = true
          getSchoolTeacherList(page, this.schoolTeacherPage.limit).then(res => {
            if (res.status === 'ok') {
              this.schoolTeacherPage.page = res.page.current_page
              this.schoolTeacherPage.total = res.page.total
              this.schoolTeacherList = res.data
            }
            else {
              this.$message.error('获取失败')
            }
          })
          setTimeout(() => {
            this.loadingTeacherData = false
          }, 500)
          break
        }
        case 'student': {
          this.loadingStudentData = true
          getClassroomStudentList(page, this.studentPage.limit, this.selectClassroom.class_id).then(res => {
            if (res.status === 'ok') {
              this.studentPage.page = res.page.current_page
              this.studentPage.total = res.page.total
              this.studentTableData = res.data
            }
          })
          setTimeout(() => {
            this.loadingStudentData = false
          }, 500)
          break
        }
        case 'classroomTeacher': {

          break
        }
        case 'log':{
          let type=''
          if(this.activePage==='teacher'){
            type='老师'
          }
          if(this.activePage==='student'){
            type='学生'
          }
          getLogList(page,this.logPage.limit,type).then(res=>{
            if(res.status==='ok'){
              this.logPage.page=res.page.current_page
              this.logPage.total=res.page.total
              this.logList=res.data
            }
          })
          break;
        }
        case 'report':{
          getReportList(page,this.reportPage.limit).then(res=>{
            if(res.status==='ok'){
              this.reportPage.page=res.page.current_page
              this.reportPage.total=res.page.total
              this.reportList=res.data
            }
          })
          break
        }
        default: { }
      }

    },

    openDia (row, target) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        switch (target) {
          case 'classroom': {
            deleteClassroom(row.id).then(res => {
              if (res.status === 'ok') {
                this.$message({ type: 'success', message: '删除成功!' });
              }
              else { this.$message.error('删除失败') }
            }).then(() => {

              this.loadingClassroomData = true
              getClassroomList(this.classroomPage.page, this.classroomPage.limit).then(res => {
                if (res.status === 'ok') {
                  this.classroomPage.total = res.page.total
                  this.classroomPage.page = res.page.current_page
                  this.classTableData = res.data
                  setTimeout(() => {
                    this.loadingClassroomData = false
                  }, 500)
                }
                else {
                  setTimeout(() => {
                    this.loadingClassroomData = false
                  }, 500)
                }
              })
            })
            break;
          }
          case 'teacher': {
            deleteTeacherFormClassroom({ class_id: this.selectClassroom.id, user_id: row.user_id }).then(res => {
              if (res.status === 'ok') {
                this.$message.success('成功')
                this.loadingClassTeacherData = true
                getClassroomTeacherList(this.selectClassroom.id).then(res => {
                  if (res.status === 'ok') {
                    this.teacherTableData = res.data
                  }
                })
                setTimeout(() => {
                  this.loadingClassTeacherData = false
                }, 500)
                this.managerShow = 'teacher'
              }
              else {
                this.$message.error('错误')
              }
            })
            break
          }
          case 'student': {

            deleteStudentFormClassroom({ class_id: this.class_id, user_id: row.user_id }).then(res => {
              if (res.status === 'ok') {
                this.$message({ type: 'success', message: '删除成功!' });
              }
              else { this.$message.error('删除失败') }
            }).then(() => {
              this.loadingStudentData = true
              getClassroomStudentList(this.studentPage.page, this.studentPage.limit, this.selectClassroom.class_id).then(res => {
                if (res.status === 'ok') {
                  this.studentPage.page = res.page.current_page
                  this.studentPage.total = res.page.total
                  this.studentTableData = res.data
                }
              })
              setTimeout(() => {
                this.loadingStudentData = false
              }, 500)
            })
            break
          }
          default: {

          }
        }

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
}
</script>

<style scoped>
.scorll-table /deep/ .gutter{
  background-color: rgb(229, 229, 229);
}
.scorll-table /deep/ .el-table__body-wrapper::-webkit-scrollbar-track-piece {
  background-color:#f8f8f8;
}
.scorll-table /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width:17px;
}
.scorll-table /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color:#dddddd;
  border-radius: 100px;
}
.scorll-table /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background-color:#bbb;
}
.class-pagination {
  margin-top: 0.5vw;
  width: 100%;
  height: 5vh;
  min-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.report-excel{
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  /*height: 70vh;*/
  /*width: 100%;*/
}
.report-excel /deep/ .cell{
  white-space: nowrap;
}
.manage-table /deep/ .cell{
  white-space: nowrap;
}
.table-btn{
  display: block;
  height: 1.5vw;
  width: 3vw;
  margin: 0 0.5vw 0;
  border-radius: 1.5vw;
  font-weight: 600;
  font-size: 0.7vw;
  line-height: 1.5vw;
  text-align: center;
  cursor: pointer;
}
.report-action-btn{
  height: 1.5vw;
  width: 4.5vw;
  background-color: transparent;
  color: black;
  border-radius: 1.5vw;
  border: 1px rgb(94, 178, 247) solid;
  font-size: 0.85vw;
  white-space: nowrap;
  min-width: 50px;
  line-height:1.5vw;
  font-family: test;
  text-align: center;
  cursor: pointer;
}
.report-action-btn:hover{
  color: white;
  border: none  ;
  background-color: rgb(94, 178, 247);
}
.delete-btn{
  background-image: url("http://data.xiyilab.com/web/main/static/exam/删除(1).png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  height: 1.2vw;
  width: 1.2vw;
  margin: 0 0.5vw 0;
  border-radius: 1.5vw;
  font-weight: 600;
  font-size: 0.7vw;
  line-height: 1.5vw;
  text-align: center;
  cursor: pointer;
}
.download-icon{
  background-image: url("http://data.xiyilab.com/web/main/static/exam/Cloud download (1).svg");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  height: 1.2vw;
  width: 1.2vw;
  border-radius: 1.5vw;
  font-weight: 600;
  font-size: 0.7vw;
  line-height: 1.5vw;
  text-align: center;
  cursor: pointer;
}
.report-action-title{
  height: 8vh;
  min-height: 40px;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

}
.report-input{
  width: 10vw;
  height: 1.5vw;
  margin-left: 0.3vw;
  margin-right: 0.5vw;
  border-radius: 1.5vw;
  border: 1px black solid;
  outline: none;
  font-size: 1vw;
}
.report-input:hover{
  border: 1px rgb(94, 178, 247) solid;
}
.report-input:focus{
  outline: none;
}

.log-input{
  width: 7vw;
  height: 1.2vw;
  margin-left: 0.3vw;
  margin-right: 0.5vw;
  border-radius: 1.2vw;
  border: 1px black solid;
  outline: none;
  font-size: 0.7vw;
}
.log-input:hover{
  border: 1px rgb(94, 178, 247) solid;
}
.log-input:focus{
  outline: none;
}
.dialog-input {
  width: 20vw;
  height: 2vw;
  border-radius: 3vw;
  font-size: 0.8vw;
  line-height: 2vw;
  outline: none;
  margin: 0.5vw 3vw 0.5vw;
  border: 1px #a0a0a0 solid;
  text-indent: 1vw;
}


.el-input--medium,
/deep/ .el-input__inner {
  border: none;
  border-bottom: 1px solid #000;
  border-radius: 0;
}
.el-input--medium,
/deep/ .el-input__inner::-webkit-input-placeholder {
  font-family: SourceHanSansCN-Regular;
  font-size: 0.8vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.5vw;
  letter-spacing: 0vw;
  color: #a0a0a0;
}

.back-img {
  position: absolute;
  z-index: -999;
  object-fit: cover;
  overflow: hidden;
}
.whole-page {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-image: url("http://data.xiyilab.com/web/main/static/home/p背景装饰.png");
  background-position: center 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment:fixed;
  -webkit-background-size: cover;/* 兼容Webkit内核浏览器如Chrome和Safari */
  -o-background-size: cover;/* 兼容Opera */
}
.header {
  height: 3vw;
}
.header {
  width: 100%;
  height: 4vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  background-color: white;
}
.header-icon {
  width: 6vw;
  height: 3vw;
  margin-top: 0.5vw;
  margin-left: 3vw;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/资源 2.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}
.header-pic {
  height: 2vw;
  width: 2vw;
  margin-top: 1vw;
  margin-right: 3vw;
  margin-left: 0.5vw;
  border-radius: 50%;
  background-image: url("http://data.xiyilab.com/web/main/static/home/小头像.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
  position: relative;
}
.user-card {
  position: absolute;
  top: 3vw;
  right: -1vw;
  min-width: 100px;
  max-width: 200px;
  width: 8vw;
  display: flex;
  flex-direction: column;
  z-index: 999;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.user-card-pic {
  width: 8vw;
  height: 4vw;
  min-width: 100px;
  min-height: 40px;
  max-height: 120px;
  background-image: url("http://data.xiyilab.com/web/main/static/home/p__卡片背景.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.user-msg {
  display: flex;
  flex-direction: column;
  width: 8vw;
  height: 4vw;
  min-width: 100px;
  min-height: 40px;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 0.7vw;
}
.user-card-btn {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  height: 2vw;
  min-height: 25px;
  cursor: pointer;
  width: 100%;
}
.user-btn-pic {
  object-fit: contain;
}
.user-btn-text {
  line-height: 2vw;
  height: 2vw;
  font-size: 0.7vw;
  text-align: center;
  margin-left: 1.5vw;
  white-space: nowrap;
}
.user-card-btn:hover {
  background-color: #f7e35e;
}
.header-title {
  margin: 1vw auto;
  height: 2vw;
  line-height: 2vw;
  font-size: 1.2vw;
  text-align: center;
}
.info-link-right-title {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  height: 2vw;
}
.right-title {
  font-size: 1vw;
  line-height: 2vw;
  height: 2vw;
}
.main {
  width: 62.5vw;
  left: 18vw;
  margin: 1.5vw auto 3vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.background-card {
  display: flex;
  flex-wrap: nowrap;
  background-color: white;
  margin-top: 3vw;
  height: 80vh;
  width: 62.5vw;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.card-left {

  width: 20%;
  background-color: #ffffff;
  box-shadow: 0vw 0.1vw 0.5vw 0vw rgba(160, 160, 160, 0.2);
}
.go-back{
  width: 6vw;
  margin-left: 0.5vw;
  height: 1.5vw;
  font-size: 0.7vw;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 999;
  white-space: nowrap;
  margin-top: 0.3vw;
  border-radius: 4px;
  color: white;
  background-color: #5eb2f7;
}
.card-right {
  width: 80%;
  height: 100%;
  background-color: #f8f8f8;
}
.card-pic {
  width: 100%;
  height: 10.5vw;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pic {
  position: absolute;
  width: 5vw;
  height: 5vw;
  top: 1.6vw;
  background-image: url("http://data.xiyilab.com/web/main/static/home/小头像.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%;
}
.pic:hover .pic-shadows {
  visibility: inherit;
}
.pic-shadows {
  cursor: pointer;
  visibility: hidden;
  position: absolute;
  top: 3.32vw;
  left: 1.1vw;
  height: 0.8vw;
  width: 2.8vw;
  background-color: rgba(0, 0, 0, 0.36);
  border-radius: 50% / 0 0 100% 100%;
  color: #dfdfdf;
  font-size: 0.5vw;
  text-align: center;
  line-height: 0.8vw;
}
.username {
  position: absolute;
  top: 6.5vw;
  width: 100%;
  text-align: center;
  height: 1.5vw;
  font-family: SourceHanSansCN-Regular;
  font-size: 0.8vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.5vw;
  letter-spacing: 0vw;
  color: #3e3a39;
  white-space: nowrap;
}

.account {
  position: absolute;
  top: 8vw;
  width: 100%;
  text-align: center;
  height: 1.5vw;
  font-family: SourceHanSansCN-Regular;
  font-size: 0.8vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.5vw;
  letter-spacing: 0vw;
  color: #3e3a39;
  white-space: nowrap;
}
.user-id{
  height: 1.5vw;
  display: inline-block;
  line-height: 1.5vw;
  margin-left: 1vw;
  background-color: rgb(255, 137, 0);
  color: white;
  border-radius: 4px;
  width: 3.5vw;
  font-size: 0.6vw;
  cursor: default;
}
.tab-title {
  width: 80%;
  margin: 2vw auto;
}
.account-line{
  height: 3vw;
  width: 80%;
  margin: 2.5vw auto 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  white-space: nowrap;
}
.line-font{
  height: 2.5vw;
  width: 8vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  cursor: pointer;
}
.line-font-left{
  width: 3px;
  height: 1.5vw;
  background-color: rgb(58, 192, 141);
}
.line-font-right{
  width: 6vw;
  height: 1.5vw;
  margin-left: 0.3vw;
  /*background-image: linear-gradient(90deg, rgb(58, 192, 141) 0%, transparent 100%);*/
  position: relative;
}
.under-line{
  width: 100%;
  height: 1px;
  background-color: #a0a0a0;
}
.account-msg {
  width: 70%;
  margin: 1vw auto 0;
  height: 4vw;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: center;
}
.msg-box {
  width: 14vw;
  height: 0.8vw;
  font-family: SourceHanSansCN-Medium;
  font-size: 0.8vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.5vw;
  letter-spacing: 0vw;
  color: #3e3a39;
  margin-top: 1vw;
  margin-bottom: 1vw;
}
.personal-msg {
  width: 80%;
  margin: 2vw auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: center;
  background-color: white;
}
.person-msg-shell{
  width: 80%;
  border-radius: 4px;
  margin: 0vw auto;
  background-color: white;
}
.radio {
  width: 20px;
  height: 20px;
  appearance: none;
  position: relative;
  outline: none;
}
.radio:before {
  content: "";
  width: 15px;
  height: 15px;
  border: 1px solid #a0a0a0;
  display: inline-block;
  border-radius: 50%;
  vertical-align: middle;
}
.radio:checked:before {
  content: "";
  width: 15px;
  height: 15px;
  border: 1px solid #a0a0a0;
  display: inline-block;
  border-radius: 50%;
  vertical-align: middle;
}
.radio:checked:after {
  content: "";
  width: 7px;
  height: 7px;
  text-align: center;
  background: #a0a0a0;
  border-radius: 50%;
  display: block;
  position: absolute;
  top: 5px;
  left: 4px;
}
.radio:checked + label {
  color: #000000;
  position: absolute;
  right: 1vw;
}
.safe-list {
  display: flex;
  flex-direction: column;
  width: 27vw;
  min-width: 500px;
  margin: 1vw auto 0;
}
.list-title {
  width: 10vw;
  height: 0.8vw;
  font-family: SourceHanSansCN-Medium;
  font-size: 0.8vw;
  font-weight: 600;
  font-stretch: normal;
  line-height: 1.5vw;
  letter-spacing: 0vw;
  color: #3e3a39;
}
.list-label {
  position: absolute;
  top: 2vw;
  width: 20vw;
  white-space: nowrap;
  height: 0.7vw;
  font-family: SourceHanSansCN-Regular;
  font-size: 0.7vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.5vw;
  letter-spacing: 0vw;
  color: #3e3a39;
}
.list-btn {
  position: absolute;
  right: 0;
  top: 0.5vw;
  font-size: 0.7vw;
  width: 7rem;

  color: #ffffff;
}
.card-list {
  display: flex;
  width: 42vw;
  height: 22vw;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 1vw auto auto;
  flex-direction: row;

}
.card {
  transition: all 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  width: 13vw;
  height: 11.5vw;
  margin: 0.5vw;
  cursor: pointer;
  border-radius: 4px;
  background-color: rgba(161, 184, 202, 0.1);
  position: relative;
}
.time-tag{
  width: 7vw;
  min-width: 120px;
  min-height: 16px;
  line-height: 1vw;
  height: 1vw;
  bottom:2.8vw;
  right: 0.2vw;
  z-index: 999;
  font-size: 12px;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  color: white;
  white-space: nowrap;
  background-color: rgba(0,0,0,.3);
  border-radius: 4px;
}
@media screen and (max-width: 1200px){
  .time-tag{
    display: none;
  }
}
.card:hover {
  cursor: pointer;
  transform: scale(1.05) translateZ(0);
}
.card:hover .card-img{
}
.card-img {
  width: 13vw;
  height: 9vw;
  display: flex;
  justify-content: center;
  align-content: center;

}
.card-title {
  height: 0.7vw;
  font-family: test;
  text-align: center;
  font-size: 0.7vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 2.5vw;
  letter-spacing: 0vw;
  color: #3e3a39;
}
.select-date {
  margin: 0 auto 0;
  width: 75%;
  height: 2vw;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.select-text {
  color: #3e3a39;
  padding: 0;
  margin: 0 1vw 0;
}
.select-text:hover {
  color: #1a8cfe;
}
.active-select-text {
  color: #1a8cfe;
}
.pagination {

  max-width: 25vw;
  margin: auto auto 0;
  display: flex;
  justify-content: center;
}


.selection {
  display: flex;
  flex-direction: column;
  width: 75%;
  margin: 0 auto 0.5vw;
}
.selection-list {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  margin: 0.3vw 0 0.3vw;
}
.selection-all {
  height: 1.5vw;
  font-size: 0.8vw;
  line-height: 1.5vw;
  color: #ededed;
  background-color: #1a8cfe;
  width: 3vw;
  border-radius: 1.5vw;
  text-align: center;
}
.selection-btn {
  height: 1.5vw;
  font-size: 0.8vw;
  line-height: 1.5vw;
  color: #a0a0a0;
  background-color: transparent;
  width: 4vw;
  border-radius: 1.5vw;
  text-align: center;
  cursor: pointer;
  margin-left: 0.5vw;
  margin-right: 0.5vw;
}
.selection-btn:hover {
  color: #ededed;
  background-color: #1a8cfe;
}
.title-icon {
  width: 20px;
  height: 24px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  display: inline-block;
}
.dialog-icon1 {
  background-image: url("http://data.xiyilab.com/web/main/static/home/弹框手机icon.png");
}
.dialog-icon2 {
  background-image: url("http://data.xiyilab.com/web/main/static/home/弹框邮箱icon.png");
}
.dialog-icon3 {
  background-image: url("http://data.xiyilab.com/web/main/static/home/弹框微信icon.png");
}
.dialog-icon4 {
  background-image: url("http://data.xiyilab.com/web/main/static/home/弹框提示icon.png");
}
.dialog-title {
  display: inline-block;
  height: 24px;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0vw;
  color: #3e3a39;
  margin-left: 1vw;
}
.title {
  display: flex;
  flex-wrap: nowrap;
}
.right-tab-line {
  position: absolute;
  top: 2vw;
  display: inline-block;
  left: 1vw;
  width: 95%;
  height: 1px;
  background-color: #a0a0a0;
  margin: 1px auto 0;
}
.right-tab-active-line {
  width: 4vw;
  height: 2px;
  position: absolute;
  z-index: 10;
  top: 2vw;
  margin-right: 1.5vw;
  background-color: #5eb2f7;
}
.right-tab-text {
  margin: 0vw 1vw 0.1vw;
  width: 4.8vw;

  height: 1.3vw;
  font-family: SourceHanSansCN-Medium;
  font-size: 0.7vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.5vw;
  letter-spacing: 0.1vw;
  white-space: nowrap;
  position: relative;
}
.classroom-select-title {
  width: 6vw;
  height: 2vw;
  font-size: 0.7vw;
  display: flex;
  flex-wrap: nowrap;
  margin-left: 7vw;
}
.class-icon {
  background-image: url("http://data.xiyilab.com/web/main/static/home/年级.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  min-width: 24px;
  min-height: 26px;
  width: 1.3vw;
  height: 1.3vw;
  margin-top: 0.3vw;
  margin-right: 0.5vw;
}
.classroom-select-title p {
  height: 2vw;
  line-height: 2vw;
  text-align: center;
}
.classroom-card-list {
  width: 75%;
  margin: 1vw auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.classroom-card {
  width: 6vw;
  height: 2vw;
  font-size: 0.7vw;
  background-color: #d7d7d7;
  margin: 0.5vw 1.5vw 0.5vw;
  line-height: 2vw;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.classroom-card:hover {
  background-color: #f7e35e;
}
.app-select-btn {
  width: 75%;
  height: 2vw;
  border-bottom: 1px #d7d7d7 solid;
  margin: 0.2vw auto 0;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.select-del {
  width: 8vw;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  font-size: 0.7vw;
  margin: auto 1vw auto;
}
.select-search-btn {
  width: 10vw;
  height: 1.7vw;
  position: relative;
  margin-left: 18vw;
  margin-top: 0.2vw;
}
.select-search-btn i {
  position: absolute;
  top: 0.3vw;
  right: 1.5vw;
}
.search-input::-webkit-input-placeholder {
  position: absolute;
  top: 0.3vw;
  left: 0.5vw;
}
.review-card-list {
  width: 75%;
  margin: 1vw auto 1vw;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
}
.student-back {
  width: 75%;
  margin: 0 auto;
}
.student-header {
  height: 3vw;
  font-size: 1vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
}
.student-icon {
  background-image: url("http://data.xiyilab.com/web/main/static/home/生物.png");
  width: 1.1vw;
  height: 1.2vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-top: 0.9vw;
  margin-right: 1vw;
}
.student-title {
  font-size: 0.8vw;
  height: 3vw;
  line-height: 3vw;
}
.student-search {
  height: 1.7vw;
  margin-top: 0.45vw;
}
.student-body {
  width: 100%;
}
.review-body {
  width: 75%;
  margin: 0 auto;
  border-radius: 10px;
}
.app-report {
}
.report-title {
  width: 75%;
  margin: 0.5vw auto;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  height: 3vw;
}
.report-icon {
  background-image: url("http://data.xiyilab.com/web/main/static/home/生物.png");
  width: 1.1vw;
  height: 1.2vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-top: 0.9vw;
  margin-right: 1vw;
}
.report-title-text {
  font-size: 0.8vw;
  height: 3vw;
  line-height: 3vw;
}
.select-btn {

  width: 80%;
  height: 5vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin:0 auto auto;
}
.btn-list {
  margin-left: 1vw;
  height: 1.5vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  margin-top: 0;
}
.label-list {
  height: 1.5vw;
  line-height: 1.5vw;
  text-align: center;
}
.btn-group {
  margin-right: auto;
  margin-left: 1vw;
}
.version-btn {
  line-height: 2vw;
  height: 2vw;
  margin-left: 1vw;
  margin-right: 1vw;
  cursor: pointer;
  width: 4vw;
}
.version-btn:hover {
  color: #5eb2f7;
}

.active {
  color: #5eb2f7;
}
.disable {
  color: black;
}
.select-tag-list {
  width: 80%;
  height: 2vw;
  margin: 0.5vw auto;
  display: flex;
  flex-wrap: nowrap;
}
.select-tag-text {
  height: 1vw;
  margin-left: 1vw;
}
.dialog-input::-webkit-input-placeholder {
  line-height: 2vw;
  /*font-size: 0.8vw;*/
  /*left:1vw;*/
  /*position: absolute;*/
}
.apply-form {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 80%;
  margin: auto;
  height: 100%;
  flex-direction: column;
}
.apply-line {
  width: 100%;
  height: 60px;
  line-height: 60px;
  margin-top: 0.5vw;
  margin-bottom: 0.5vw;
  display: flex;
  flex-wrap: nowrap;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
}
.apply-line  /deep/ .el-input__inner{
  height: 1.5vw;
  border: none;

}
.apply-btn-line {
  margin-top: 1vw;
  width: 100%;
}
.apply-label {
  line-height: 2vw;
  height: 2vw;
  margin-left: 1vw;
  margin-right: 1vw;
  cursor: pointer;
  font-size: 0.6vw;
  width: 2.5vw;
  display: inline-block;
  text-align: justify;
  vertical-align: top;
  min-width: 50px;
}
.apply-label::after {
  width: 100%;
  display: inline-block;
  content: "";
}

.manage-input {
  min-width: 50px;
  width: 5vw;
  height: 3vh;
  margin: auto 10px auto;
  font-size: 0.7vw;
}
.dialog-label {
  width: 4vw;
  text-align: justify;
  margin-top: 1vw;
  vertical-align: top;
}
.dialog-label::after {
  width: 100%;
  display: inline-block;
  content: "";
}
.line-input {
  height: 2vw;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin:0.5vw auto 0.5vw ;
}
.line-input>input {
  padding-left:10px
}
.search-line {
  height: 20px;
  position: absolute;
  top: 0.8vw;
  right: 1vw;
}
.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 6vh;
  line-height: 6vh;
}
.el-table__body tr, /deep/  .el-table__body td {
  padding: 0;
  height: 5vh;
  line-height: 5vh;
}
.phy-back{
  background-image: url("http://data.xiyilab.com/web/main/static/实验/物理.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.chem-back{
  background-image: url("http://data.xiyilab.com/web/main/static/实验/化学.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.bio-back{
  background-image: url("http://data.xiyilab.com/web/main/static/实验/生物.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.red-point {
  position: absolute;
  width: 0.7vw;
  height: 0.7vw;
  min-width: 14px;
  min-height: 14px;
  background-color: red;
  border-radius: 50%;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.message-ding {
  height: 1.5vw;
  width: 1.5vw;
  margin-top: 1.25vw;
  margin-left: 3vw;
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 50%;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  position: relative;
}
.card-right::-webkit-scrollbar{
  display: none;
}
</style>
